window.theme = window.theme || {};
window.slate = window.slate || {};

/* ================ SLATE ================ */
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _loadSubSections: function() {
    if (AOS) {
      AOS.refreshHard();
    }
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    src = src || '';

    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match === null) {
      return null;
    } else {
      return match[1];
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      for (var e = selectedValues, s = variants, found = _.find(s, function(variant) {
        return e.every(function(values) {
          return _.isEqual(variant[values.index], values.value)
        })
      }), r = 0; r < e.length; r++) {
      var t = r + 1;
      $(".js-swatch-display--" + t).text(e[r].value)
    }
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = new URL(window.location.href);
      newurl.searchParams.set('variant', variant.id);
      window.history.replaceState({ path: newurl.href }, '', newurl.href);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/*================ MODULES ================*/
theme.Drawers = (function() {
  var Drawer = function(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('body, html'),
      $page: $('.page-element')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
    
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
      
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.js-drawer-close').first(),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode !== 27) return;

        this.close();
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) return;

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();

window.Modals = (function() {
  var Modal = function(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active'
    };

    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $body: $('body')
    };

    this.config = $.extend(defaults, options);

    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen
      ? $(this.config.focusOnOpen)
      : this.$modal;
    this.init();
  };

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$modal.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      return this.close();
    }

    this.$modal.prepareTransition().addClass(this.config.openClass);
    this.nodes.$body.addClass(this.config.openClass);

    this.modalIsOpen = true;

    // Set focus on modal
    slate.a11y.trapFocus({
      $container: this.$modal,
      namespace: 'modal_focus',
      $elementToFocus: this.$focusOnOpen
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal.prepareTransition().removeClass(this.config.openClass);
    this.nodes.$body.removeClass(this.config.openClass);

    this.modalIsOpen = false;

    // Remove focus on modal
    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$body.on(
      'keyup.modal',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }, this)
    );
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$body.off('.modal');
  };

  return Modal;
})();

window.QtySelector = (function() {
  var QtySelector = function($el) {
    this.cache = {
      $body: $('body'),
      $subtotal: $('#CartSubtotal'),
      $discountTotal: $('#cartDiscountTotal'),
      $cartTable: $('.cart-table'),
      $cartTemplate: $('#CartProducts')
    };

    this.settings = {
      loadingClass: 'js-qty--is-loading',
      isCartTemplate: this.cache.$body.hasClass('template-cart'),
      // On the cart template, minimum is 0. Elsewhere min is 1
      minQty: this.cache.$body.hasClass('template-cart') ? 0 : 1
    };

    this.$el = $el;
    this.qtyUpdateTimeout;
    this.createInputs();
    this.bindEvents();
  };

  QtySelector.prototype.createInputs = function() {
    var $el = this.$el;

    var data = {
      value: $el.val(),
      key: $el.attr('id'),
      name: $el.attr('name'),
      line: $el.attr('data-line')
    };
    var source = $('#QuantityTemplate').html();
    var template = Handlebars.compile(source);

    this.$wrapper = $(template(data)).insertBefore($el);

    // Remove original number input
    $el.remove();
  };

  QtySelector.prototype.validateAvailability = function(line, quantity) {
    var product = theme.cartObject.items[line - 1]; // 0-based index in API
    var handle = product.handle; // needed for the ajax request
    var id = product.id; // needed to find right variant from ajax results

    var params = {
      type: 'GET',
      url: '/products/' + handle + '.js',
      dataType: 'json',
      success: $.proxy(function(cartProduct) {
        this.validateAvailabilityCallback(line, quantity, id, cartProduct);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.validateAvailabilityCallback = function(
    line,
    quantity,
    id,
    product
  ) {
    var quantityIsAvailable = true;

    // This returns all variants of a product.
    // Loop through them to get our desired one.
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.id === id) {
        break;
      }
    }

    // If the variant tracks inventory and does not sell when sold out
    // we can compare the requested with available quantity
    if (
      variant.inventory_management !== null &&
      variant.inventory_policy === 'deny'
    ) {
      if (variant.inventory_quantity < quantity) {

        // Set quantity to max amount available
        this.$wrapper.find('.js-qty__input').val(variant.inventory_quantity);

        quantityIsAvailable = false;
        this.$wrapper.removeClass(this.settings.loadingClass);
      }
    }

    if (quantityIsAvailable) {
      this.updateItemQuantity(line, quantity);
    }
  };

  QtySelector.prototype.validateQty = function(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return parseInt(qty, 10);
  };

  QtySelector.prototype.adjustQty = function(evt) {
    var $el = $(evt.currentTarget);
    var $input = $el.siblings('.js-qty__input');
    var qty = this.validateQty($input.val());
    var line = $input.attr('data-line');

    if ($el.hasClass('js-qty__adjust--minus')) {
      qty -= 1;
      if (qty <= this.settings.minQty) {
        qty = this.settings.minQty;
      }
    } else {
      qty += 1;
    }

    if (this.settings.isCartTemplate) {
      $el.parent().addClass(this.settings.loadingClass);
      this.updateCartItemPrice(line, qty);
    } else {
      $input.val(qty);
    }
  };

  QtySelector.prototype.bindEvents = function() {
    this.$wrapper
      .find('.js-qty__adjust')
      .on('click', $.proxy(this.adjustQty, this));

    // Select input text on click
    this.$wrapper.on('click', '.js-qty__input', function() {
      this.setSelectionRange(0, this.value.length);
    });

    // If the quantity changes on the cart template, update the price
    if (this.settings.isCartTemplate) {
      this.$wrapper.on(
        'change',
        '.js-qty__input',
        $.proxy(function(evt) {
          var $input = $(evt.currentTarget);
          var line = $input.attr('data-line');
          var qty = this.validateQty($input.val());
          $input.parent().addClass(this.settings.loadingClass);
          this.updateCartItemPrice(line, qty);
        }, this)
      );
    }
  };

  QtySelector.prototype.updateCartItemPrice = function(line, qty) {
    // Update cart after short timeout so user doesn't create simultaneous ajax calls
    clearTimeout(this.qtyUpdateTimeout);
    this.qtyUpdateTimeout = setTimeout(
      $.proxy(function() {
        this.validateAvailability(line, qty);
      }, this),
      200
    );
  };

  QtySelector.prototype.updateItemQuantity = function(line, quantity) {
    var params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: $.proxy(function(cart) {
        this.updateCartItemCallback(cart);
      }, this)
    };

    $.ajax(params);
  };

  QtySelector.prototype.updateCartItemCallback = function(cart) {
    // Reload the page to show the empty cart if no items
    if (cart.item_count === 0) {
      location.reload();
      return;
    }

    // Update cart object
    theme.cartObject = cart;

    // Handlebars.js cart layout
    var data = {};
    var items = [];
    var item = {};
    var source = $('#CartProductTemplate').html();
    var template = Handlebars.compile(source);
    var prodImg;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add 240x240, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */

      if (cartItem.image === null) {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      } else {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_240x240$1')
          .replace('http:', '');
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemQty: cartItem.quantity,
        price: theme.Currency.formatMoney(cartItem.price, theme.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: theme.Currency.formatMoney(
          cartItem.line_price,
          theme.moneyFormat
        ),
        originalLinePrice: theme.Currency.formatMoney(
          cartItem.original_line_price,
          theme.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
      //theme.updateCurrencies();
    });

    // Gather all cart data and add to DOM
    data = {
      items: items
    };
    this.cache.$cartTemplate.empty().append(template(data));

    // Create new quantity selectors
    this.cache.$cartTable.find('input[type="number"]').each(function(i, el) {
      new QtySelector($(el));
    });

    // Update the cart subtotal
    this.cache.$subtotal.html(
      theme.Currency.formatMoney(cart.total_price, theme.moneyFormat)
    );

    // Update the cart total discounts
    if (cart.total_discount > 0) {
      this.cache.$discountTotal.html(
        theme.strings.totalCartDiscount.replace(
          '[savings]',
          theme.Currency.formatMoney(cart.total_discount, theme.moneyFormat)
        )
      );
    } else {
      this.cache.$discountTotal.empty();
    }
    
    theme.miniCart.updateElements();
    //theme.updateCurrencies();
    // Set focus on cart table
    slate.a11y.pageLinkFocus(this.cache.$cartTable);
  };

  return QtySelector;
})();

/*
  Allow product to be added to cart via ajax with
  custom success and error responses.
*/
window.AjaxCart = (function() {
  var styleCart = $('.js-mini-cart').attr("data-cartmini");
  var cart = function($form) {
    this.cache = {
      $cartIconIndicator: $('.site-header__cart-indicator')
    };

    this.$form = $form;
    this.eventListeners();
    
    this.showNotice = false;
    if (this.$form.length) {
      this.showNotice  = this.$form.hasClass('js-form--notice')? true : false;
    }
  };

  cart.prototype.eventListeners = function() {
    if (this.$form.length) {
      this.$form.on('submit', $.proxy(this.addItemFromForm, this));
    }
  };

  cart.prototype.addItemFromForm = function(evt) {
    // console.log(evt);
    evt.preventDefault();
    var $form = this.$form;
    var $submitButton = $form.find('button[type="submit"]');
    $submitButton.addClass('is-loading');
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: this.$form.serialize(),
      dataType: 'json',
      success: $.proxy(function(lineItem) {
        this.success(lineItem);
      }, this),
      error: $.proxy(function(XMLHttpRequest, textStatus) {
        this.error(XMLHttpRequest, textStatus);
      }, this),
      complete: function() {
        $submitButton.removeClass('is-loading');
      }
    };
    $.ajax(params);
  };
  
  cart.prototype.success = function(item) {
    theme.miniCart.generateCart();
    if(styleCart != 'true' ){
      if (this.showNotice) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
      }else{
        theme.crosssell.showPopup(item);
      }
    }
  };

  // Error handling reference from Shopify.onError in api.jquery.js
  cart.prototype.error = function(XMLHttpRequest) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    
    if (data.message) {
      theme.alert.new('',data.description,3000,'warning');
    }
  };

  return cart;
})();

/*================ SECTIONS ================*/
theme.HeaderSection = (function() {
  function HeaderSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var stickyId = $container.attr('data-sticky');
    theme.NavDrawer = new theme.Drawers('NavDrawer', 'left');
    this.selectors = {
      headerID : '.section-' + sectionId,
      typeHeader : stickyId ,
    }
    this.init();
    
  }
  HeaderSection.prototype = _.assignIn({}, HeaderSection.prototype, {
    init: function() {
      this.stickyHeader();
      this.headerSearch();
      this.headerHeight();
      this.delayMenu();
    },
    headerHeight : function(){
      var header = document.querySelector('.site-header');
      var rootElement = document.querySelector(':root');
      rootElement.style.setProperty("--height-header", header.offsetHeight + "px");
    },
    headerSearch: function(){
      let modalOpen   = document.querySelector(".modal__toggle-open"),
          searchMobile = document.querySelector(".modal__toggle-search-mobile");

      function openSpotlight(e){
        if (!window.SpotlightSearch) return;
        e.preventDefault();
        e.stopPropagation();
        SpotlightSearch.open();
      }

      if (modalOpen)    modalOpen.addEventListener("click", openSpotlight);
      if (searchMobile) searchMobile.addEventListener("click", openSpotlight);
    },
    // Stickyheader
    stickyHeader: function() {
      var stickHeaderClass = this.selectors.headerID ;
      var stickyHeader =  this.selectors.typeHeader;
      var offsetHeight = document.querySelector(stickHeaderClass).clientHeight.toString();
      

      var prevScrollpos = window.pageYOffset;
      if( stickyHeader === 'sticky' ){
        window.onscroll = function() {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > 30) {
            document.querySelector(stickHeaderClass).classList.add("active");
          } else {
            document.querySelector(stickHeaderClass).classList.remove("active");
          }
          prevScrollpos = currentScrollPos;
        }
      }
      else if (stickyHeader === 'sticky-top' ){ 
        const mediaQuery = window.matchMedia('(min-width: 1000px)')
        
        window.onscroll = function() {
          var currentScrollPos = window.pageYOffset;
          if (prevScrollpos > currentScrollPos && prevScrollpos - currentScrollPos > offsetHeight) {
            function responsiveHeader(){
              if (mediaQuery.matches) {
                document.querySelector(stickHeaderClass).style.top = "0";
              }
            }
            responsiveHeader();
            document.addEventListener("resize", event => {responsiveHeader()});
            if(currentScrollPos == 0){
              document.querySelector(stickHeaderClass).classList.remove("active");
            }
            else{
              document.querySelector(stickHeaderClass).classList.add("active");
            }
            
          } else if (currentScrollPos - prevScrollpos > offsetHeight) {
            function responsiveHeader2(){
              if (mediaQuery.matches) {
                document.querySelector(stickHeaderClass).style.top = `-${offsetHeight}px`;
              }
            }
            responsiveHeader2();
            document.addEventListener("resize", event => {responsiveHeader2()});
            document.querySelector(stickHeaderClass).classList.remove("active");
          }
          prevScrollpos = currentScrollPos;
        }
        
      }
      else{
        return null;
      }
    },
    // hoverMenu
    delayMenu: function(){
      var megaMenu = $('.site-nav__item-mega');  
      megaMenu.each(function( index ) {
        var childLink = $(this).find('.d-col-link');
        childLink.each(function( i ) {
          $(this).css("animation-delay", `${(i+1)/10 * 0.8}s`);
        });
      });
    }
  });

  return HeaderSection;
})();

theme.CartDraw = (function() {
  theme.testDrawer = new theme.Drawers('testDrawer', 'left');
  /*$('.drawer-crossell-product').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    dots: false,
    arrows:true,
    infinite:false,
  });*/
  /*$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree_checkout').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  });*/
})();

theme.Product = (function() {
  var defaults = {
    smallBreakpoint: 750,
    productThumbIndex: 0,
    productThumbMax: 0,
    ajaxCart: false,
    stockSetting: false
  };

  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var sectionTem = $container.attr('data-id');

    this.selectors = {
      originalSelectorId: '#ProductSelect-' + sectionId,
      modal: 'ProductModal',
      productZoomImage: '#ProductZoomImg',
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      SKU: '.js-variant-sku',
      productImageMain: '.gallery-wrap'+ sectionId,
      productImageContainers: '.product__photo-container-' + sectionId,
      productImageWrappers: '.product__photo-wrapper-' + sectionId,
      productThumbContainers: '.product-single__thumbnail-item-' + sectionId,
      productThumbsWrapper: '.product-single__thumbnails-' + sectionId,
      productThumbs: '.product-single__thumbnail-' + sectionId,
      saleTag: '#ProductSaleTag-' + sectionId,
      productStock: '#ProductStock-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      availability: '.product-single__availability',
      hurrify : '.js-hurrify',
      txtHurrify : '.js-hurrify .js-txt-hurrify',
      labelwrap_sale: '.product-tag-sale',
      numbersale_change : '.product-tag-sale-number'

    };
    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      sectionTem:sectionTem,
      ajaxCart: $container.data('ajax'),
      stockSetting: $container.data('stock'),
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId
    });

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      $('#ProductJson-' + sectionId).html()
    );
    this.addVariantInfo();

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this._stringOverrides();
      this._initVariants();
      this._initProductGallery();
      this._initQtySelector();

      if (this.settings.ajaxCart) {
        theme.AjaxCart = new window.AjaxCart(
          $('#AddToCartForm-' + this.settings.sectionId)
        );
      }
    },

    _stringOverrides: function() {
      window.productStrings = window.productStrings || {};
      $.extend(theme.strings, window.productStrings);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject || !this.settings.stockSetting) {
        return;
      }

      var variantInfo = JSON.parse(
        $('#VariantJson-' + this.settings.sectionId).html()
      );

      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      // eslint-disable-next-line no-new
      this.variants = new slate.Variants(options);
      var variant = this.variants
      if( variant.currentVariant.compare_at_price > variant.currentVariant.price){
        var load_sale_minus = variant.currentVariant.compare_at_price - variant.currentVariant.price;
        var load_sale_per = load_sale_minus*100 / variant.currentVariant.compare_at_price;
        var load_roundNumber = parseInt(load_sale_per);
        $(this.selectors.numbersale_change).text(`${load_roundNumber}%`);
        $(this.selectors.labelwrap_sale).removeClass('hide');
      }else{
        $(this.selectors.labelwrap_sale).addClass('hide');
      }
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCartBtn.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateStickyCart.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateSwatchTitle.bind(this)
      );
    },

    _updateStock: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock),
          $hurrify = $(this.selectors.hurrify),
          $txtHurrify  = $(this.selectors.txtHurrify);

      // If we don't track variant inventory, hide stock
      if (!variant || !variant.inventory_management) {
        $stock.addClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
        $stock
          .html(
            theme.strings.stockAvailable.replace(
              '1',
              variant.inventory_quantity
            )
          )
          .removeClass('hide');
        $hurrify.removeClass('hide').find('.progress-bar').css('width',variant.inventory_quantity*10+'%');
        $txtHurrify.html(
          theme.strings.stringHurrify.replace(
            'number',
            variant.inventory_quantity
          )
        );
        // console.log(variant.inventory_quantity);
        return;
      }

      if (variant.inventory_quantity <= 0 && variant.incoming) {
        $stock
          .html(
            theme.strings.willNotShipUntil.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        $hurrify.addClass('hide');
        return;
      }

      // If there's more than 10 available, hide stock
      $stock.addClass('hide');
      $hurrify.addClass('hide');
    },

    _updateIncomingInfo: function(variant) {
      if (!this.settings.stockSetting) return;

      var $stock = $(this.selectors.productStock);

      if (variant.incoming) {
        $stock
          .html(
            theme.strings.willBeInStockAfter.replace(
              '[date]',
              variant.next_incoming_date
            )
          )
          .removeClass('hide');
        return;
      }

      // If there is no stock incoming, hide stock
      $stock.addClass('hide');
    },

    _updateAddToCartBtn: function(evt) {
      var variant = evt.variant;


      var cache = {
        $addToCart: $(this.selectors.addToCart),
        $addToCartText: $(this.selectors.addToCartText)
      };

      if (variant) {
       
        let optionName = this.productSingleObject.options;
        
        // Select a valid variant if available
        //theme.noticeSoldout.init(variant);
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('btn--sold-out').prop('disabled', false);
          cache.$addToCartText.html(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
          // Show how many items are left, if below 10
          this._updateStock(variant);
          //update availability - available
          $(this.selectors.availability).find('span').text(theme.strings.available);
          $('.product__pickup-availabilities').show();
          const a1 = optionName,
                a2 = variant.options,
                someFunction = (...values) => values.join(' '),
                knownValue = ":",
                output = a1.map((value1, i) => someFunction(value1, knownValue, a2[i]));
          $('.pickup-availability-variant').text(output.join(", "));
          
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.prop('disabled', true).addClass('btn--sold-out');
          cache.$addToCartText.html(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
          // Update when stock will be available
          this._updateIncomingInfo(variant);
          //update availability - soldout
          $(this.selectors.availability).find('span').text(theme.strings.soldOut);
          $('.product__pickup-availabilities').hide();
        }
      } else {
        cache.$addToCart.prop('disabled', true).removeClass('btn--sold-out');
        cache.$addToCartText.html(theme.strings.unavailable);
        //update availability - unavailable
        $(this.selectors.availability).find('span').text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
        // Hide stock display
        this._updateStock();
        $('.product__pickup-availabilities').hide();
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrice).html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          var sale_minus = variant.compare_at_price - variant.price;
          var sale_per = sale_minus*100/variant.compare_at_price
          var roundNumber = parseInt(sale_per);
          $(this.selectors.numbersale_change).text(`${roundNumber}%`);
          $(this.selectors.labelwrap_sale).removeClass('hide');

          $(this.selectors.comparePrice)
            .html(
              theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
              )
            )
            .removeClass('hide');
          $(this.selectors.saleTag).removeClass('hide');
        } else {
          $(this.selectors.comparePrice).addClass('hide');
          $(this.selectors.saleTag).addClass('hide');
          $(this.selectors.labelwrap_sale).addClass('hide');
        }
        
        //theme.updateCurrencies();
      } else {
        
        $(this.selectors.comparePrice).addClass('hide');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.SKU).html(variant.sku);
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;

      if (variant && variant.featured_media) {
        var imageId = variant.featured_media.id;
        this.switchProductImage(imageId);
        this.setActiveThumbnail(imageId);
      }
    },
    _updateSwatchTitle: function(e) {
      const {variant} = e; 
			for (var e = 1; e <= e.length; e++) {
        var option = "option" + e;
        $(".js-swatch-display--" + e).text(variant[option])
      }
		},

    _updateStickyCart: function (evt){
      var variant = evt.variant,
          $stickyPrice = $('#js-sticky-price'),
          $stickyTitle = $('#js-sticky-title'),
          $stickyImage = $('#js-sticky-img'),
          $stickyButton = $('#js-sticky-btn');
      if (variant) {
        //update title
        $stickyTitle.html(' - ' + variant.title);
        //update price
        $stickyPrice.html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
        //update selectbox
        for (var i = 1; i <= 3; i++) {
          var option = 'option' + i,
              $selecBox = '#js-sticky-option-' + i;
          if (variant[option] !== null){
            var valueOption = variant[option];
            $($selecBox).val(valueOption);
          }
        }
        //update button cart
        if (variant.available) {
          $stickyButton.prop('disabled', false).removeClass('btn--sold-out');
          $stickyButton.html(theme.strings.addToCart);
        } else {
          $stickyButton.prop('disabled', true).addClass('btn--sold-out');
          $stickyButton.html(theme.strings.soldOut);
        }
        //update image
        if (variant.featured_image) {
          $stickyImage.attr('src',theme.Images.getSizedImageUrl(variant.featured_image.src,'200x'));
        }
      } else {
        //update title
        $stickyTitle.html(' - ' + theme.strings.unavailable);
        //update button cart
        $stickyButton.prop('disabled', true).removeClass('btn--sold-out');
        $stickyButton.html(theme.strings.unavailable);
      }
    },

    switchProductImage: function(imageId) {
      if (this.productGallery) {
        this.productGallery.switchToImageId(imageId);
      }
    },

    setActiveThumbnail: function() {
      // Handled internally by ProductGallery
    },

    _initProductGallery: function() {
      var galleryEl = this.$container.find('[data-product-gallery]')[0];
      if (galleryEl && window.ProductGallery) {
        this.productGallery = new window.ProductGallery(galleryEl);
      }
    },

    _initQtySelector: function() {
      this.$container.find('.product-form__quantity').each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    onUnload: function() {
      if (this.productGallery) {
        this.productGallery.destroy();
      }
    }
  });

  return Product;
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    dots: '.slick-dots',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    this.navArrow = this.$slideshow.data('arrow');
    this.navDot = this.$slideshow.data('dot');
    this.transit = this.$slideshow.data('transit');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');
    this.settings = {
      rtl:theme.rtl,
      accessibility: false,
      arrows: this.navArrow,
      dots:  this.navDot,
      fade:  (this.transit === 'slide' ? false : true),
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      pauseOnFocus: this.autorotate? false:true, 
      pauseOnHover: this.autorotate? false:true,
      useTransform: true,
      infinite: true,
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);
    this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if ($(this).data('transit') === 'slide-fade' ) {
          var $outGoing = $(slick.$slides.get(currentSlide));
          $outGoing.addClass('slick-going');
        }
    });
    this.$slideshow.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $(slick.$slides).filter('.slick-going').removeClass('slick-going');
    });
    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();
    
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

//     this.$wrapper.on('keyup', keyboardNavigation.bind(this));
//     this.$controls.on('keyup', keyboardNavigation.bind(this));
//     this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');
    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

//   function keyboardNavigation() {
//     if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
//       this.$slideshow.slick('slickPrev');
//     }
//     if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
//       this.$slideshow.slick('slickNext');
//     }
//   }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.Cart = (function() {
  var selectors = {
    cartNote: '#CartSpecialInstructions',
    cartQtyInput: '.cart__quantity',
    cartNoCookiesClass: 'cart--no-cookies'
  };

  function Cart(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    theme.cartObject = JSON.parse($('#CartJson-' + sectionId).html());

    this.init($container);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function($container) {
      this._initQtySelector();
      this._initCartNote();

      if (!this._cookiesEnabled()) {
        $container.addClass(selectors.cartNoCookiesClass);
      }
    },

    _initQtySelector: function() {
      $(selectors.cartQtyInput).each(function(i, el) {
        // eslint-disable-next-line no-new
        new QtySelector($(el));
      });
    },

    _initCartNote: function() {
      if (!$(selectors.cartNote).length) {
        return;
      }

      var $el = $(selectors.cartNote);
      var noteText;
      var params;
      var noteOffset = $el[0].offsetHeight - $el[0].clientHeight;

      // Auto grow the cart note if text fills it up
      $el.on('keyup input', function() {
        $(this)
          .css('height', 'auto')
          .css('height', $el[0].scrollHeight + noteOffset);
          
      });
      // Save the cart note via ajax. A safeguard in case
      // a user decides to leave the page before clicking 'Update Cart'
      $el.on(
        'change',
        $.proxy(function() {
          noteText = $el.val();
          params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + this._attributeToString(noteText),
            dataType: 'json'
          };
          $.ajax(params);
          
        }, this)
      );
    },

    _attributeToString: function(attr) {
      if (typeof attr !== 'string') {
        attr = String(attr);
        if (attr === 'undefined') {
          attr = '';
        }
      }
      return $.trim(attr);
    },

    _cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

theme.noteCart = (function() {
  if($('.block-notecart') != undefined ){
    var $el = $('#cart__note');
    var $btnsubmit = $('.cart-notes-submit');
    var $editNote = $('.edit-notecart');
    var $closeNote = $('.cart-note-close');
    var $drawCart = $('.mini-cart-content');
    var noteText;
    function noteUpdate(noteText){
        params = {
          type: 'POST',
          url: '/cart/update.js',
          data: 'note=' + theme.attributeToString(noteText)
        };
        $.ajax(params);
    }
    $btnsubmit.on( "click", function() {
      noteText = $el.val();
      noteUpdate(noteText);
      $(this).closest('.js-note-cart').removeClass('active');
    });
    $editNote.on( "click", function() {
      $(this).siblings().toggleClass('active');
      $(this).closest($drawCart).toggleClass('overlay');
    });
    $closeNote.on( "click", function() {
      $(this).closest('.js-note-cart').removeClass('active');
      $(this).closest($drawCart).removeClass('overlay');
    });
  }
  
})();
theme.attributeToString = function(attribute) {
	if (typeof attribute !== 'string') {
		attribute += '';
		if (attribute === 'undefined') {
			attribute = '';
		}
	}
	return jQuery.trim(attribute);
}

// Instagrams
theme.Instagrams = (function() {
  function Instagrams(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    //console.log(this.$container);
    this.settings = {
      style 			: this.$container.data('style'),
      accesstoken 		: this.$container.data('accesstoken'),
      userid			: this.$container.data('userid'),
      limit 			: this.$container.data('limit'),
      resolution 		: this.$container.data('resolution'),
      target 			: this.$container.attr('id'),
      rows 			: this.$container.data('rows'),
      
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      draggable 		: this.$container.data('draggable') || false,
      dots 				: this.$container.data('dots') || false,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= 2;
    
    var _self = this;
    var $instagramSelector = $('#'+this.settings.target);
    if (this.settings.style === 'grid'){
      var afterInstagram = function(){} // blank function
    }else if (this.settings.style === 'carousel'){
      var afterInstagram = function(){
        $instagramSelector.slick({
          slidesToShow		: _self.settings.slidesToShow,
          slidesToScroll	: _self.settings.slidesToShow,
          arrows			: _self.settings.arrows,
          dots				: _self.settings.dots,
          draggable		 	: _self.settings.draggable,
          infinite		 	: _self.settings.infinite,
          rows : _self.settings.rows,
          accessibility:false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow	: _self.settings.slidesToShow1200,
                slidesToScroll	: _self.settings.slidesToShow1200,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow	: _self.settings.slidesToShow992,
                slidesToScroll	: _self.settings.slidesToShow992,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow	: _self.settings.slidesToShow768,
                slidesToScroll	: _self.settings.slidesToShow768,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow	: _self.settings.slidesToShow480,
                slidesToScroll	: _self.settings.slidesToShow480,
              }
            }
          ]
        })
      }
    }

    var feed = new Instafeed({
      get			: 'user',
      target 		: this.settings.target,
      userId		: this.settings.userid,
      accessToken	: this.settings.accesstoken,
      limit			: this.settings.limit,
      resolution	: this.settings.resolution,
      template		: '<div class="col hv-image-brightness"><a class="instagram-item" href="{{link}}" target="_blank" id="{{id}}"><img alt="instagram image" class="transition lazyload" data-src="{{image}}" /></a></div>',
      after			: afterInstagram
    });

    feed.run();
  }

  Instagrams.prototype = _.assignIn({}, Instagrams.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Instagrams;
})();

// Slick carousel
theme.slickCarousel = (function (){
  function Carousels(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      rows 				: this.$container.data('rows') || 1,
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      slidesToScroll	: this.$container.data('slidestoscroll') || 1,
      infinite 			: this.$container.data('infinite') || false,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      autoplay 			: this.$container.data('autoplay') || false,
      draggable 		: this.$container.data('draggable') || false,
      accessibility 	: this.$container.data('accessibility') || false,
      slidesToShowMobile 		: this.$container.data('slidestoshow-mobile') || 1,
    }
    this.settings.slidesToShow1200 		= (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  		= (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  		= (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  		= (this.settings.slidesToShow - 4) > 1? (this.settings.slidesToShow - 4) : 1;
    this.settings.slidesToScroll1200 	= (this.settings.slidesToScroll - 1) > 1? (this.settings.slidesToScroll - 1) : 1;
    this.settings.slidesToScroll992  	= (this.settings.slidesToScroll - 2) > 1? (this.settings.slidesToScroll - 2) : 1;
    this.settings.slidesToScroll768  	= (this.settings.slidesToScroll - 3) > 1? (this.settings.slidesToScroll - 3) : 1;
    this.settings.slidesToScroll480  	= (this.settings.slidesToScroll - 4) > 1? (this.settings.slidesToScroll - 4) : 1;
    this.$container.slick({
      rtl				: theme.rtl,
      rows 				: this.settings.rows,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll 	: this.settings.slidesToScroll,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: this.settings.autoplay,
      accessibility		: this.settings.accessibility,
      draggable			: this.settings.draggable,
      infinite			: this.settings.infinite,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: this.settings.slidesToShow1200,
            slidesToScroll: this.settings.slidesToScroll1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: this.settings.slidesToShow992,
            slidesToScroll: this.settings.slidesToScroll992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: this.settings.slidesToShow768,
            slidesToScroll: this.settings.slidesToScroll768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: this.settings.slidesToShowMobile,
            slidesToScroll: this.settings.slidesToShowMobile
          }
        }
      ]
    }).css('opacity','1');
   
    if($('.shopthelook').length){
      var $container = (this.$container = $(container)),
          sectionId = $container.attr('data-section-id'),
          $dotID = $container.closest('.shopthelook').find(`#dot-${sectionId}`).find("li");
          $dotID.click(function(){
            var pos = $(this).data('pos');
            $dotID.removeClass('active');
            $(this).addClass("active");
            // console.log($container);
            $container.slick("slickGoTo", pos);
          });
          $container.on('afterChange', function(event, slick, currentSlide, nextSlide){
              var $dotPos = $container.closest('.shopthelook').find(`#dot-${sectionId}`).find(`li[data-pos=${currentSlide}]`);
              $dotID.removeClass('active');
              $dotPos.addClass('active');
          });
    }
    
  }

  Carousels.prototype = _.assignIn({}, Carousels.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this._goToSlide(slideIndex);
      
    }
  });

  return Carousels;
})()

// Slick Press
theme.slickPress = (function (){
  function slickPress(container) {

    this.$container = $(container).on('init', this._a11y.bind(this));
    var sectionId = this.$container.data('section-id');
    var pressSub = '#sub-'+ sectionId;
    
    this.settings = {
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
    }
      this.$container.slick({
      rtl				: theme.rtl,
      rows 				: 1,
      slidesToShow		: 1,
      slidesToScroll 	: 1,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      autoplay			: false,
      accessibility		: true,
      draggable			: true,
      infinite			: true,
      adaptiveHeight: true,
      asNavFor: pressSub,
      
    }).css('opacity','1');

    $(pressSub).slick({
      slidesToShow		: 3,
      slidesToScroll 	: 1,
      infinite			: true,
      arrows			: false,
      asNavFor: this.$container,
      draggable			: true,
      accessibility		: true,
      focusOnSelect: true,
      centerMode: true,
      centerPadding: '0px',
    });
  }

  slickPress.prototype = _.assignIn({}, slickPress.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container;
      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },
    
    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete  this.$container;
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.carousel__slide-wrapper--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      // console.log(this);
      this._goToSlide(slideIndex);
      
    }
  });

  return slickPress;
})()

// Productlists
theme.Productlists = (function() {
  function Productlists(container) {
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.settings = {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      rows 				: this.$container.data('rows') || 1,
      arrows 			: this.$container.data('arrows') || false,
      dots 				: this.$container.data('dots') || false,
      draggable 		: this.$container.data('draggable') || false,
      infinite 			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 2;
    this.$container.slick({
      rtl				: theme.rtl,
      accessibility		: false,
      slidesToShow		: this.settings.slidesToShow,
      slidesToScroll	: this.settings.slidesToShow,
      rows				: this.settings.rows,
      arrows			: this.settings.arrows,
      dots				: this.settings.dots,
      infinite 			: this.settings.infinite,
      draggable			: this.settings.draggable,
      responsive		: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow	: this.settings.slidesToShow1200,
            slidesToScroll	: this.settings.slidesToShow1200
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow	: this.settings.slidesToShow992,
            slidesToScroll	: this.settings.slidesToShow992
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow	: this.settings.slidesToShow768,
            slidesToScroll	: this.settings.slidesToShow768
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow	: this.settings.slidesToShow480,
            slidesToScroll	: this.settings.slidesToShow480
          }
        }
      ]
    }).css('opacity','1');
  }

  Productlists.prototype = _.assignIn({}, Productlists.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _goToSlide: function(slideIndex) {
      this.$container.slick('slickGoTo', slideIndex);
    },

    onUnload: function() {
      delete this.$container;
    }
  });

  return Productlists;
})();

// Producttabs
theme.Producttabs = (function() {
  function Producttabs(container) {
    var _self = this; // avoid conflict
    this.$container = $(container).on('init', this._a11y.bind(this));
    this.slickWrap 	= '.prdtab-content';
    this.settings 	= {
      slidesToShow 		: this.$container.data('slidestoshow') || 1,
      arrows 			: this.$container.data('arrows') || false,
      rows 				: this.$container.data('rows') || 1,
      dots 				: this.$container.data('dots') || false,
      draggable			: this.$container.data('draggable') || false,
      infinite			: this.$container.data('infinite') || false,
    }
    this.settings.slidesToShow1200 = (this.settings.slidesToShow - 1) > 1? (this.settings.slidesToShow - 1) : 1;
    this.settings.slidesToShow992  = (this.settings.slidesToShow - 2) > 1? (this.settings.slidesToShow - 2) : 1;
    this.settings.slidesToShow768  = (this.settings.slidesToShow - 3) > 1? (this.settings.slidesToShow - 3) : 1;
    this.settings.slidesToShow480  = 2;

    this._initSlick();
    this.$container.find('a[data-toggle="tab"]').on("shown.bs.tab", function(e) {
      _self._unSlick();
      _self._initSlick();
      theme.tooltip.load();
    })
  }

  Producttabs.prototype = _.assignIn({}, Producttabs.prototype, {
    _a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = this.$container.parent();

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    },

    _getSliderSettings : function (){
      return {
        rtl				: theme.rtl,
        accessibility	: true,
        slidesToShow	: this.settings.slidesToShow,
        slidesToScroll	: this.settings.slidesToShow,
        arrows			: this.settings.arrows,
        rows			: this.settings.rows,
        dots			: this.settings.dots,
        infinite 		: this.settings.infinite,
        draggable		: this.settings.draggable,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: this.settings.slidesToShow1200,
              slidesToScroll: this.settings.slidesToShow1200
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: this.settings.slidesToShow992,
              slidesToScroll: this.settings.slidesToShow992
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: this.settings.slidesToShow768,
              slidesToScroll: this.settings.slidesToShow768
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: this.settings.slidesToShow480,
              slidesToScroll: this.settings.slidesToShow480
            }
          }
        ]
      }
    },

    _initSlick : function (){
      this.$container.find(this.slickWrap).slick(this._getSliderSettings()).css('opacity','1');
    },

    _unSlick : function(){
      this.$container.find(this.slickWrap).slick('unslick');
    },

    onUnload: function() {
      delete this.$container;
    },

    onSelect: function() {
      this._unSlick();
      this._initSlick();
    },

    onBlockSelect: function(evt) {
      var navItem = $('.nav-link-' + evt.detail.blockId);
      navItem.tab('show');
      this._unSlick();
      this._initSlick();
    }
  });

  return Producttabs;
})();

theme.Video = (function() {
  var promiseYoutubeAPI;
  var promiseVimeoAPI;

  var youtube = {
    promiseAPI: function() {
      if (!promiseYoutubeAPI) {
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        promiseYoutubeAPI = $.Deferred(function(defer) {
          window.onYouTubeIframeAPIReady = defer.resolve;

          setTimeout(function() {
            defer.reject('Request for YouTube API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseYoutubeAPI;
    },
    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.YT === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The YouTube API has not loaded correctly."
            );
          }

          /* eslint-disable no-undef */
          var player = new YT.Player(id, options); // global YT variable injected by YouTube API

          player.addEventListener('onReady', function() {
            defer.resolve(player);
          });

          setTimeout(function() {
            defer.reject(
              'Request for YouTube player has timed out after 30 seconds.'
            );
          }, 30000);
        });
      });
    }
  };

  var vimeo = {
    promiseAPI: function() {
      if (!promiseVimeoAPI) {
        promiseVimeoAPI = $.Deferred(function(defer) {
          var tag = document.createElement('script');
          tag.src = 'https://player.vimeo.com/api/player.js';
          tag.onload = tag.onreadystatechange = function() {
            if (!this.readyState || this.readyState === 'complete') {
              defer.resolve();
            }
          };

          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          setTimeout(function() {
            defer.reject('Request for Vimeo API timed out after 30 seconds.');
          }, 30000);
        });
      }

      return promiseVimeoAPI;
    },

    promisePlayer: function(id, options) {
      return this.promiseAPI().then(function() {
        return $.Deferred(function(defer) {
          if (typeof window.Vimeo === 'undefined') {
            defer.reject(
              "We're sorry, something went wrong. The Vimeo API has not loaded correctly."
            );
          }

          var player = new window.Vimeo.Player(id, options);

          setTimeout(function() {
            defer.reject(
              'Request for Vimeo player has timed out after 30 seconds.'
            );
          }, 30000);

          player.ready().then(function() {
            defer.resolve(player);
          });
        });
      });
    }
  };

  var selectors = {
    loadPlayerButton: '.video-section__load-player-button',
    closePlayerButton: '.video-section__player-close',
    playerContainer: '.video-section__player',
    cover: '.video-section__cover',
    errorMessage: '.video-section__error',
    bodyOverlay: '.video-section__body-overlay',
    body: 'body'
  };
  var classes = {
    playerLoading: 'video-section--loading',
    playerLoaded: 'video-section--loaded',
    playerError: 'video-section--error',
    videoPlaying: 'video-playing'
  };

  function Video(container) {
    this.$container = $(container);
    var sectionId = this.$container.attr('data-section-id');
    this.namespace = '.' + sectionId;
    this.onLoad();
  }

  Video.prototype = _.assignIn({}, Video.prototype, {
    onLoad: function() {
      this.$container
        .on('click', selectors.loadPlayerButton, this._loadPlayer.bind(this))
        .on('click', selectors.closePlayerButton, this._closePlayer.bind(this))
        .on('click', selectors.bodyOverlay, this._closePlayer.bind(this));
    },

    _loadPlayer: function() {
      var $container = this.$container;
      var $playerContainer = $(selectors.playerContainer, $container);
      var playerType = this.$container.attr('data-video-type');

      var promiseVideoPlayer;

      if (playerType === 'youtube') {
        promiseVideoPlayer = this._loadYoutubePlayer($playerContainer[0]);
      } else if (playerType === 'vimeo') {
        promiseVideoPlayer = this._loadVimeoPlayer($playerContainer[0]);
      }

      return promiseVideoPlayer
        .then(this._onPlayerLoadReady.bind(this))
        .fail(this._onPlayerLoadError.bind(this));
    },

    _loadYoutubePlayer: function(container) {
      return youtube
        .promisePlayer(container, {
          videoId: this.$container.attr('data-video-id'),
          ratio: 16 / 9,
          playerVars: {
            modestbranding: 1,
            autoplay: 1,
            showinfo: 0,
            rel: 0
          }
        })
        .then(
          function(player) {
            this.player = player;
          }.bind(this)
        );
    },

    _loadVimeoPlayer: function(container) {
      return vimeo
        .promisePlayer(container, {
          id: this.$container.attr('data-video-id')
        })
        .then(
          function(player) {
            this.player = player;
            this.player.play();
          }.bind(this)
        );
    },

    _onPlayerLoadReady: function() {
      $(selectors.closePlayerButton, this.$container)
        .show()
        .focus();
      $(selectors.cover, this.$container).addClass(classes.playerLoaded);
      this.$container.addClass(classes.playerLoaded);

      this._setScrollPositionValues();

      $(selectors.body).addClass(classes.videoPlaying);

      $(document).on('keyup' + this.namespace, this._closeOnEscape.bind(this));
      $(window).on(
        'resize' + this.namespace,
        this._setScrollPositionValues.bind(this)
      );
      slate.a11y.trapFocus({
        $container: this.$container,
        namespace: this.namespace
      });
    },

    _onPlayerLoadError: function(err) {
      this.$container.addClass(classes.playerError);
      $(selectors.errorMessage, this.$container).text(err);
    },

    _closeOnEscape: function(evt) {
      if (evt.keyCode !== 27) {
        return;
      }

      this._closePlayer();
      $(selectors.loadPlayerButton, this.$container).focus();
    },

    _onScroll: function() {
      var scrollTop = $(window).scrollTop();

      if (
        scrollTop > this.videoTop + 0.25 * this.videoHeight ||
        scrollTop + this.windowHeight <
          this.videoBottom - 0.25 * this.videoHeight
      ) {
        // Debounce DOM edits to the next frame with requestAnimationFrame
        requestAnimationFrame(this._closePlayer.bind(this));
      }
    },

    _setScrollPositionValues: function() {
      this.videoHeight = this.$container.outerHeight(true);
      this.videoTop = this.$container.offset().top;
      this.videoBottom = this.videoTop + this.videoHeight;
      this.windowHeight = $(window).innerHeight();
    },

    _closePlayer: function() {
      $(selectors.body).removeClass(classes.videoPlaying);
      $(selectors.cover, this.$container).removeClass(classes.playerLoaded);
      this.$container.removeClass(classes.playerLoaded);
      $(selectors.closePlayerButton, this.$container).hide();

      slate.a11y.removeTrapFocus({
        $container: this.$container,
        namespace: this.namespace
      });

      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      } else if (typeof this.player.unload === 'function') {
        this.player.unload();
      }

      $(document).off(this.namespace);
      $(window).off(this.namespace);
    }
  });

  return Video;
})();

theme.CollectionsList = (function() {
  function CollectionsList(container) {
    var $container = (this.$container = $(container));
    var stretchImage = $container.is('[data-stretch-image]');

    // Early return if 'secondary image layout' is enabled
    if (stretchImage) return;

    var namespace = (this.namespace = '.' + $container.attr('data-section-id'));
    var self = this;

    self._collectionListFix();
    $(window).on(
      'resize' + namespace,
      $.debounce(250, function() {
        self._collectionListFix();
      })
    );
  }

  CollectionsList.prototype = _.assignIn({}, CollectionsList.prototype, {
    onUnload: function() {
      $(window).off(this.namespace);
    },

    _collectionListFix: function() {
      var numberRows = this.$container.find('.grid').data('number-rows');
      var $featureCards = this.$container.find('.featured-card');

      // We can exit if 'Use secondary image layout' is enabled
      if ($featureCards.is('[data-stretch-image]')) return;

      // Go through each of the rows
      for (var i = 0; i < numberRows; i++) {
        var maxWrapperHeight = 0;
        var maxHeaderHeight = 0;
        var $currentRow = $featureCards.filter(
          "[data-row-number='" + (i + 1) + "']"
        );
        var $cardHeaders = $currentRow.find('.featured-card__header');

        // Find the max heights for each row
        $currentRow.each(function() {
          var $cardTitle = $(this).find('.featured-card__title');
          var $cardAction = $(this).find('.featured-card__action');
          var $cardImageWrapper = $(this).find('.featured-card__image-wrapper');
          var headerHeight =
            $cardTitle.outerHeight() + $cardAction.outerHeight() + 65;
          var wrapperHeight = $cardImageWrapper.outerHeight();
          if (headerHeight > maxHeaderHeight) {
            maxHeaderHeight = headerHeight;
          }
          if (wrapperHeight > maxWrapperHeight) {
            maxWrapperHeight = wrapperHeight;
          }
        });

        // Set the heights of the headers and cards for this row with padding
        $cardHeaders.outerHeight(maxHeaderHeight);
        $currentRow.height(maxWrapperHeight + maxHeaderHeight + 40);
      }
    }
  });

  return CollectionsList;
})();


theme.SwiperCustom = (function() {
  function SwiperCustom(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.nav = '.swiper-wrapper-' + this.sectionId;
    this.namespace = '.swipercol-' + this.sectionId;
    var perviewDesktop= $(container).data('perview-desktop');
    var perviewMobile= $(container).data('perview-mobile') || 2.2;
    var spaceBetween= $(container).data('space-between');
    var swiper = new Swiper(this.namespace, {
      slidesPerView: "auto",
      freeMode: false,
      autoHeight: true,
      calculateHeight:true,
      freeModeSticky: true,
      centeredSlides: false,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      spaceBetween: spaceBetween,
      observer: true,
      observeParents: true,
      parallax:true,
      a11y: true,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        320: {
          slidesPerView: perviewMobile,
          spaceBetween: 20
        },
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: perviewDesktop,
        },
      },
      scrollbar: {
        el: $(this.namespace).find(".swiper-scrollbar")[0],
      },
      navigation: {
        nextEl: $(this.nav).find(".swiper-button-next")[0],
        prevEl: $(this.nav).find(".swiper-button-prev")[0],
      },
    });
   
  }
  return SwiperCustom;
})();


theme.AnnouncementSwiper = (function() {
  function AnnouncementSwiper(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.announswipercol-' + this.sectionId;
    var rootElement = document.querySelector(':root');
    var anNounBar = document.querySelector('.announcement-bar-carousel');
    rootElement.style.setProperty("--height-announbar", anNounBar.offsetHeight + "px");
    var swiper = new Swiper(this.namespace, {
      slidesPerView:1,
      loop: $(this.namespace).find(".slider .slide").length == 1 ? true: false,
      autoHeight: true,
      calculateHeight:true,
      observer: true,
      a11y: true,
      navigation: {
        nextEl: $(this.namespace).find(".swiper-button-next")[0],
        prevEl: $(this.namespace).find(".swiper-button-prev")[0],
      }
    });
  }
  return AnnouncementSwiper;
})();

theme.init = function() {
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });


    //scroll animation
    
  AOS.init({
    startEvent: 'DOMContentLoaded',
    offset: 30, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 700,
    once: true
  });
  
  window.addEventListener('load', function() {
    AOS.refresh();
  });
  document.querySelectorAll('img')
    .forEach((img) =>
        img.addEventListener('load', () =>
            AOS.refresh()
        )
    );
  


  // Sections
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('cart', theme.Cart);
  sections.register('instagrams', theme.Instagrams);
  sections.register('productlist', theme.Productlists);
  sections.register('producttab', theme.Producttabs);
  sections.register('slickCarousels', theme.slickCarousel);
  sections.register('slickPress', theme.slickPress);
  sections.register('video', theme.Video);
  sections.register('collections-list', theme.CollectionsList);
  sections.register('bgcollection',theme.Bgcollection);
  sections.register('swipercustom',theme.SwiperCustom);
  sections.register('announcementswiper',theme.AnnouncementSwiper);
  sections.register('popupnewletter', theme.popupNewletter);
  sections.register('beforeafter', theme.BeforeAfter);
  sections.register('bundleproduct', theme.bundleProduct);
  sections.register('footer', theme.FooterSection);
  sections.register('promo-code', theme.CouponCode);
  

  // Standalone modules
  $(window).on('load', theme.articleImages);
  theme.passwordModalInit();
};

theme.articleImages = function() {
  var $indentedRteImages = $('.rte--indented-images');
  if (!$indentedRteImages.length) {
    return;
  }

  $indentedRteImages.find('img').each(function(i, el) {
    var $el = $(el);
    var attr = $el.attr('style');

    // Check if undefined or float: none
    if (!attr || attr === 'float: none;') {
      // Add class to parent paragraph tag if image is wider than container
      if ($el.width() >= $indentedRteImages.width()) {
        $el.parent('p').addClass('rte__image-indent');
      }
    }
  });
};

theme.passwordModalInit = function() {
  var $loginModal = $('#LoginModal');
  if (!$loginModal.length) {
    return;
  }

  // Initialize modal
  theme.PasswordModal = new window.Modals('LoginModal', 'login-modal', {
    focusOnOpen: '#Password'
  });

  // Open modal if errors exist
  if ($loginModal.find('.errors').length) {
    theme.PasswordModal.open();
  }
};

// CSS var ponyfill
theme.cssVar = (function() {
  cssVars();
})()

// Ajax search https://gist.github.com/awojtczyk/53d74c8af5f893841f33979b0cdcd6fe
theme.ajaxSearch = (function() {
  var $inputSearch = '.js-ajaxsearch',
      $resultsList = '.search-results',
      $trendSearch = '.search-trend',
      $input = $($inputSearch).find('input[name="q"]'),
      $currentAjaxRequest,
      $displayProducts = 5;

  $($inputSearch).css('position', 'relative').each(function() {
    $input.attr('autocomplete', 'off').bind('keyup change', function() {
      var term = $(this).val(),
          form = $(this).closest('form'),
          searchURL = '/search?type=product&q=*' + term + '*';
      if (term.length > 2 && term !== $(this).attr('data-old-term')) {
        $(this).attr('data-old-term', term);
        if ($currentAjaxRequest !== undefined) $currentAjaxRequest.abort();
        $currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
          $($resultsList).empty();

          if (data.results_count === 0) {
            $($resultsList).html('<p class="text-center">'+ theme.strings.ajaxSearchNoResult +'</p>')
          } else {
            $.each(data.results, function(index, item) {
              if (index < $displayProducts){
                var itemPrice = theme.Currency.formatMoney(item.price, theme.moneyFormat);
                var link = $('<a class="d-inline-flex '+index+'"></a>')
                .attr('href', item.url)
                .append('<span class="image"><img src="' + item.thumbnail + '" /></span>')
                .append('<div class="meta d-flex align-items-start flex-column justify-content-center"><p class="title h6 mb-1">' + item.title + '</p>'+itemPrice+'</div>')
                .wrap('<div class="ajax-search-item"></div>');
                $($resultsList).append(link.parent());
                //theme.updateCurrencies();
              }
            });
            if (data.results_count > $displayProducts) {
              $($resultsList).append('<a class="btn btn--full btn-outline" href="' + searchURL + '">'+ theme.strings.ajaxSearchViewAll +' (' + data.results_count + ')</a>');
            }
          }
          $($resultsList).addClass('active').fadeIn(200);
          $($trendSearch).hide();
        });
      }
    });
  });
  $input.on("input",function()
    {
      if( !this.value ) {
        $($resultsList).slideUp(300);
        $($trendSearch).show();
        // console.log('11');
      }
    });
  //escape when click somethings
  $(document).click(function(event) {
    var target = event.target;
    if (!$(target).is($inputSearch) && !$(target).parents().is($inputSearch)) {
      $($resultsList).slideUp(300);
      $($trendSearch).show();
    }
  });
})();

// Quickview https://github.com/kellyvaughn/quickview-for-shopify/blob/master/quickview.js.liquid
theme.quickview = (function() {
  var product_handle = '',
      quickviewButtonClass = '.js-btn-quickview',
      quickviewId = '#jsQuickview',
      quickviewOption = '#jsQuickview select',
      quickviewThumb = '#qv-product-images',
      quickviewAddCartButton = '.qv-add-button',
      quickviewPrice = '.qv-product-price',
      quickviewComparePrice = '.qv-product-compare-price';
      quickLoad = '#loading_qv';
      quickQty = '.popup-quantity';
  // 1. Show quickview
  $(quickLoad).removeClass('activeload');
  $(quickviewId).removeClass('loadqvpopup');

  //quanity quickview
  
  $(".qv-qtity").on("click", function () {
    var $button = $(this);
    var oldValue = $button.closest(quickQty).find("input.qv-quantity").val();
    if ($button.text() == "+") {
        var newVal = parseFloat(oldValue) + 1;
    } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
            var newVal = parseFloat(oldValue) - 1;
        } else {
            newVal = 1;
        }
    }
    $button.closest(quickQty).find("input.qv-quantity").val(newVal);
  });
  //click
  $(document).on('click',quickviewButtonClass, function() {
    $(quickQty).find("input.qv-quantity").val(1);
    //ResetQuickview
    $(quickLoad).addClass('activeload');
    var qv_color = $(quickviewId).data('color');
    var quickviewAvaible = $(this).attr("data-pavailable");
    var jdmgReview = $(this).attr("data-viewjdmg");
    product_handle = $(this).data('handle');
    $(quickviewThumb).removeClass().empty();
    $('.qv-product-options').empty().removeClass('pb-3');
    var desc = $(this).find('.txt-short').text();
    
    //Pushdata
    $(quickviewId).addClass(product_handle).data('handle',product_handle);
      $.getJSON({
        url: '/products/' + product_handle + '.js?' + new Date().getTime(),
        beforeSend: function() {
          $(quickviewButtonClass+`[data-handle=${product_handle}]`).addClass('qv-loading');
        },
        
      }).done(function(product) {
        $(quickviewId).removeClass().addClass('modal fade show loadqvpopup');
        var title = product.title;
        var type = product.type;
        var vendor = product.vendor;
        var price = 0;
        var compare_price = 0;
        var images = product.images;
        var variants = product.variants;
        var options = product.options;
        var url = '/products/' + product_handle;
        
        $('.qv-product-title').text(title);
        function renderReview(){
          if(window.SPR &&  theme.review ){
            $('.qv-product-rv').html(`<span class="shopify-product-reviews-badge" data-id="${product.id}"></span>`);
            return window.SPR.registerCallbacks(),
            window.SPR.initRatingHandler(),
            window.SPR.initDomEls(),
            window.SPR.loadProducts(),
            window.SPR.loadBadges()
          }
          if(theme.review && jdmgReview != ''){
            $('.qv-product-rv').html(`<div class='jdgm-widget jdgm-preview-badge py-1 small'  data-id='${ product.id }' data-auto-install="false">${jdmgReview}</div>`);
            return jdgm.customizeBadges();
          }
        }
        renderReview();
        $('.qv-product-type').text(type);
        $('.qv-product-description').html(desc);
        $('.qv-view-product').attr('href', url);
        $('.qv-view-product').click(function(){
          window.location.href = url;
        });
        $('.qv-view-type').text(type);
        $('.qv-view-vendor').text(vendor);
        if ($('.qv-product-description').is(':empty')){
          $('.qv-product-description').removeClass('mb-1');
        }
        else{
          $('.qv-product-description').addClass('mb-1');
        }
        if(quickviewAvaible == 'true'){
          $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
        }
        else{
          $(quickviewAddCartButton).prop('disabled', true).html(theme.strings.soldOut);
        }
        $(product.variants).each(function(i,variants) {
          if(variants.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(product.variants[0].sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          
        });
        var imageCount = $(images).length;
        $(images).each(function(i, image) {
          image_embed = '<div><img class="lazyload" role="presentation" data-src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
          $(quickviewThumb).append(image_embed);
        });
        $(quickviewThumb).slick({
          rtl:theme.rtl,
          'dots': true,
          'arrows': true,
          'respondTo': 'min',
          'useTransform': true
        }).css('opacity', '1');
  
        if (product.variants[0].option1 !== "Default Title"){
          $(options).each(function(i, option) {
            var name = option.name;
            var opt = name.replace(/ /g, '-').toLowerCase();
            var selectClass = '.option.' + opt;
            $('.qv-product-options').append('<div class="option-selection ' + opt + '"><span class="option text-body  ">' + option.name + ' :<span class="pl-2 txt-body-70 js-option-label-'+i+' ">'+option.values[0]+'</span></span><select class="option-' + i + ' option ' + opt + '"></select></div>').addClass('pb-3');
            $(option.values).each(function(i, value) {
              $('.option.' + opt).append($('<option>', {
                value: value,
                text: value
              }));
            });
            //list
            if ($("#jsQuickview").data('type') == 'list') {
              var str = '<div class="single-option-radio js-option-' + i + ' ">';
              if (option.name == 'Color') {
                var k = i + 1;
              }
              
              //option.values = option.values.sort();
              $(option.values).each(function(i, value) {
                var cl="";
                if (i == 0){
                  cl="active";
                }
                if (option.name == 'Color') {
                  var variant_img = '';
                  for (cc = 0; cc < variants.length; cc++) { 
                    if (variants[cc]['option'+k] == value) {
                      variant_img = variants[cc]['featured_image']['src']; 
                    }
                  }
                  
                  if (variant_img == '') {
                    str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                  } else {
                    if(qv_color){
                      var file = variant_img;
                      var nvl = value.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase();
                      const escapedValue = CSS.escape(nvl);
                      file = file.slice(0, file.lastIndexOf("/products"));
                      str += '<label class="have-background st-color-'+escapedValue+' '+cl+'" data-value="'+value+'" style="background-color:'+value+';">'+value+'</label>';	
                    }
                    else{
                      str += '<label class="have-background '+cl+'" data-value="'+value+'" style="background-image:url('+variant_img+')">'+value+'</label>';	
                    }                  
                     
                  }
                  
                } else{
                  str += '<label class="'+cl+'" data-value="'+value+'">'+value+'</label>';
                }
                
              });
              str += '</div>';
              $(`.option-selection.${opt}`).append(str);
            }
          });
          if ($("#jsQuickview").data('type') == 'list') {
            $("#jsQuickview .option-selection label").click(function(){
  
              $(this).closest('.option-selection').find('select').val($(this).data('value'));
              $(this).closest('.option-selection').find('label').removeClass('active');
              $(this).addClass('active');
              
              var arr_option = [];
              $("#jsQuickview").find('select.option').each(function(){
                arr_option.push($(this).val());
              });
              var status = true;
              var variant = '';
              for (i=0; i<variants.length; i++) {
                var status = true;
                for (j=0; j<arr_option.length; j++) {
                  if (arr_option[j] != variants[i]['options'][j]) {
                    status = false;
                  }
                }
                if (variants[i]['available'] == false) {
                    status = false;
                }
                if (status == true) {
                  variant = variants[i];
                }
              }
              //console.log(variant);
              //console.log(variant['available']);
              if (variant != '' || variant['available']) {
                $(".qv-add-button").prop( "disabled", false );
                
              } else {
                $(".qv-add-button").prop("disabled", true).html(theme.strings.unavailable);
              }
              
              
              var selectedOptions = '';
              $(quickviewOption).each(function(i) {
                if (selectedOptions == '') {
                  selectedOptions = $(this).val();
                } else {
                  selectedOptions = selectedOptions + ' / ' + $(this).val();
                }
              });
              var targetVl = $(this).data("value");
              for (i=0; i<variants.length; i++) {
                $(this).closest('.option-selection').find('.js-option-label-'+i+'').text(targetVl);
              }
              
              jQuery.getJSON(`/products/${product_handle}.js`, function(product) {
                $(product.variants).each(function(i, v) {
                  if (v.title == selectedOptions) {
                    if (v.featured_image !== null){
                      var iSlick = v.featured_image.position - 1;
                      $(quickviewThumb).slick('slickGoTo', iSlick);
                    }
                    var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
                    var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
                    $(quickviewPrice).html(price);
                    $(quickviewComparePrice).html(compare_price);
                    if (v.compare_at_price !== null) {
                      $(quickviewComparePrice).html(compare_price).show();
                    } else {
                      $(quickviewComparePrice).hide();
                    }
                    //theme.updateCurrencies();
                    
                    if (v) {
                      if (v.available == true) {
                        $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
                      }
                      else {
                        $(quickviewAddCartButton).prop('disabled', true).html(theme.strings.soldOut);
                      }
                    }
                    else {
                      $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.unavailable);
                    }
                  }
  
                });
              });
  
            });
          }
        }
        $(product.variants).each(function(i, v) {
          price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          //theme.updateCurrencies();
          //v.inventory_quantity == 0 && v.inventory_management == 'shopify'
          if (v.inventory_quantity == 0 && v.inventory_management == 'shopify') {
            $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            return true
          } else {
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
       
      }).fail(function() {
      // console.log( "error" );
    }).always(function() {
        $(quickviewButtonClass+`[data-handle=${product_handle}]`).removeClass('qv-loading');
        $(quickLoad).removeClass('activeload');
    });
    //addCartQuickview
  });
  $(quickviewId).on("hidden.bs.modal", function () {
    $(quickviewId).removeClass('loadqvpopup');
    $(quickLoad).removeClass('activeload');
  });
  // 2. Add to cart
  $(document).on('click',quickviewAddCartButton, function(){
    product_handle = $(quickviewId).data('handle');
    var spinner = '<div class="product-card__loading spinner-border d-block" role="status"></div>';
    var qty = $('.qv-quantity').val(),
        selectedOptions = '',
        var_id = '';
    function processCart() {
      $.post({
        url: '/cart/add.js',
        data: {
          quantity: qty,
          id: var_id
        },
        dataType: 'json',
        beforeSend: function() {
          $(quickviewAddCartButton).html(spinner);
        }
      })
      .done(function(item) {
        var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
        var styleCart = $('.js-mini-cart').attr("data-cartmini");
        
        if(styleCart != 'true'){
        var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice');
        }
        
        theme.miniCart.generateCart();

        if(theme.cartpage){
          location.reload();
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
      })
      .fail(function($xhr) {
        var data = $xhr.responseJSON;
        theme.alert.new('',data.description,3000,'warning');
      }).always(function() {
        $(quickviewAddCartButton).prop('disabled', false).html(theme.strings.addToCart);
        $(quickviewId).modal('hide');
      });
    }
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      if (product.variants.length === 1){
        var_id = product.variants[0].id;
      }else{
        $(product.variants).each(function(i, v) {
          if (v.title == selectedOptions) {
            var_id = v.id;
          }
        });
      }
      processCart();
    });
  });
  // 3. Select variants
  $(document).on('change', quickviewOption, function() {
    var selectedOptions = '';
    $(quickviewOption).each(function(i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
      $(product.variants).each(function(i, v) {
        
        if (v.title == selectedOptions) {
          if (v.featured_image !== null){
            var iSlick = v.featured_image.position - 1;
            $(quickviewThumb).slick('slickGoTo', iSlick);
          }
          var price = theme.Currency.formatMoney(v.price, theme.moneyFormat);
          var compare_price = theme.Currency.formatMoney(v.compare_at_price, theme.moneyFormat);
          $(quickviewPrice).html(price);
          $(quickviewComparePrice).html(compare_price);
          if(v.sku != null){
            $('.qv-sku').addClass("show").removeClass("hide");
            $('.qv-view-sku').text(v.sku);
          }
          else{
            $('.qv-sku').addClass("hide").removeClass("show");
          }
          if (v.compare_at_price !== null) {
            $(quickviewComparePrice).html(compare_price).show();
          } else {
            $(quickviewComparePrice).hide();
          }
          //theme.updateCurrencies();
          if (v.inventory_management === null) {
            $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
          } else {
            if (v.inventory_quantity < 1) {
              $(quickviewAddCartButton).prop('disabled', true).val(theme.strings.soldOut);
            } else {
              $(quickviewAddCartButton).prop('disabled', false).val(theme.strings.addToCart);
            }
          }
        }
      });
    });
  });
})()

// Button add to cart (in grid item)
theme.addCartButton = (function(){
  var buttonClass = '.js-grid-cart';
  $(document).on('click',buttonClass,function(){
    var $this = $(this);
    var id = $this.data('id');
    $this.addClass('is-loading');
    Shopify.addItem(id,1,function(item){
      var htmlVariant = item.variant_title !== null ? '<i>('+item.variant_title+')</i>' : '';
      var styleCart = $('.js-mini-cart').attr("data-cartmini");
        if(styleCart != 'true'){
          var htmlAlert = '<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="'+item.image+'"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">'+item.product_title+' x '+ item.quantity +'</p>'+htmlVariant+'<div><div>';
        }
        theme.miniCart.generateCart();
        setTimeout(function() {
          styleCart != 'true' ? theme.alert.new(theme.strings.addToCartSuccess,htmlAlert,3000,'notice'): '';

          $this.removeClass('is-loading');
        }, 300);
        if(theme.cartpage){
          location.reload();
          $("html, body").animate({ scrollTop: 0 }, "slow");
        }
    });
    
  })
})()

theme.GiftWrap = (function(){
  var openBox = '.open-gift',
      giftWrap = '.giftwrap'
      addGift    = '.add-gift',
      boxGift = '.boxgift',
      closeBtn = '.close-gift__btn',
      idGift = $(addGift).data('id'),
      cartDraw = $('.mini-cart-content');
  $(document).on('click',openBox,function(){
    $(this).next().addClass('active');
    $(this).closest(cartDraw).addClass('overlay');
  });
  $(document).on('click',closeBtn,function(){
    $(this).closest(boxGift).removeClass('active');
    $(this).closest(cartDraw).removeClass('overlay');
  });
  function addGiftInCart() {
    
    $(document).on('click',addGift,function(e){
      e.preventDefault();
      $(this).addClass('is-loading');
      
      Shopify.addItem(idGift,1,function(item){
        //console.log(item);
          theme.miniCart.generateCart();
          setTimeout(function() {
            $(this).removeClass('is-loading');
          },300);
          if(theme.cartpage){
            location.reload();
            $("html, body").animate({ scrollTop: 0 }, "normal");
          }
      });
      
    })
  }
  addGiftInCart();
  function hideGift(id){
    if(id === idGift){
      $(giftWrap).addClass('hide');
      $(boxGift).removeClass('active');
      $(addGift).removeClass('is-loading');
      $(cartDraw).removeClass('overlay');
    } 
  }
  function checkGift(id){
    if(id === idGift){
      $(giftWrap).removeClass('hide');
      $(boxGift).removeClass('active');
      $(addGift).removeClass('is-loading');
      $(cartDraw).removeClass('overlay');
    } 
  }
  return{
    
    hideGift:hideGift,
    checkGift: checkGift,
  }
})()

theme.openAddon = (function(){
  var openBlock = '.js-open-addon',
      closeBlock = '.btn-close-addon',
      addonBlock = '.block-addon__box--wrap'
      cartDraw = $('.mini-cart-content');
      $(document).on('click',openBlock,function(){
        $(this).next().addClass('active');
        $(this).closest(cartDraw).addClass('overlay');
      });
      $(document).on('click',closeBlock,function(){
        $(this).closest(addonBlock).removeClass('active');
        $(this).closest(cartDraw).removeClass('overlay');
      });
})()



// MiniCart
theme.miniCart = (function(){
  var miniCart = '.js-mini-cart',
      styleCart = $(miniCart).attr("data-cartmini"),
      cartToggle = '.js-toggle-cart',
      cartCount = '.js-cart-count',
      cartContent = '.js-mini-cart-content',
      cartTotal = '.js-cart-total',
      $crosellcart = '.drawer-crossell',
      $cartBottom = '.js-cart-bottom',
      $btnCheckout = $('.js-cart-btn-checkout'),
      numberDisplayed = 5,
      buttonHtml = '<a class="btn btn-outline w-100 mt-5" href='+theme.strings.cartCollection+'>'+theme.strings.cartEmptyButton+'</a>',
      emptyCartHTML = '<div class="alert mini-cart-empty h-100 d-flex align-items-center flex-column justify-content-center"><div class=""><div class="iconcart-empty">'+theme.strings.cartIcon+'</div><div class="txtcart-empty mt-4">'+theme.strings.cartEmpty+'</div>'+buttonHtml+'</div></div>',
      cartimgsize = $(cartContent).attr('data-sizeimg');


  function updateElements(cart){
    // Accept cart data directly to avoid redundant /cart.js fetch
    function applyCartData(c) {
      if (c.item_count === 0) {
        $(cartContent).html(emptyCartHTML);
        $(`${$cartBottom}, ${$crosellcart}`).hide(100);
      } else {
        $(`${$cartBottom}, ${$crosellcart}`).show(100);
      }
      $(cartCount).text(c.item_count);
      $(cartTotal).html(theme.Currency.formatMoney(c.total_price, theme.moneyFormat));
      theme.freeShipping.load(c);
    }
    if (cart) {
      applyCartData(cart);
    } else {
      Shopify.getCart(function(c){ applyCartData(c); });
    }
  }
  
  
// ============================================================================
// ASYNC CART FUNCTIONS - Much faster with modern async/await
// ============================================================================

// Async helper to get cart data (with retry on 429)
async function getCartData(retries) {
  if (retries === undefined) retries = 3;
  if (attempt === undefined) var attempt = 0;
  try {
    const response = await fetch('/cart.js');
    if (response.status === 429 && retries > 0) {
      var delay = Math.min(1000 * Math.pow(2, attempt), 8000);
      await new Promise(function(r) { setTimeout(r, delay); });
      return getCartData(retries - 1, attempt + 1);
    }
    if (!response.ok) throw new Error('Failed to fetch cart');
    return await response.json();
  } catch (error) {
    if (error.message !== 'Failed to fetch cart') {
      console.error('Error fetching cart:', error);
    }
    throw error;
  }
}

// Async helper to update cart item quantity (with retry on 429)
async function updateCartItemQuantity(itemKey, quantity, retries, attempt) {
  if (retries === undefined) retries = 3;
  if (attempt === undefined) attempt = 0;
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: itemKey, quantity: quantity })
    });

    if (response.status === 429 && retries > 0) {
      // Exponential backoff: 1.5s, 3s, 6s
      var delay = Math.min(1500 * Math.pow(2, attempt), 8000);
      await new Promise(function(r) { setTimeout(r, delay); });
      return updateCartItemQuantity(itemKey, quantity, retries - 1, attempt + 1);
    }

    if (!response.ok) {
      var errorMsg = 'Failed to update cart';
      try {
        var errorData = await response.json();
        errorMsg = errorData.description || errorData.message || errorMsg;
      } catch(e) { /* response wasn't JSON (e.g. HTML on 429) */ }
      throw new Error(errorMsg);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating cart:', error);
    throw error;
  }
}

// ============================================================================
// UNIFIED ADD TO CART - Single source of truth for all add-to-cart actions
// ============================================================================

// Helper to detect stock-related errors from Shopify
function isStockError(errorMessage) {
  if (!errorMessage) return false;
  const msg = errorMessage.toLowerCase();
  return (
    (msg.includes('all') && msg.includes('in your cart')) ||
    msg.includes('not enough') ||
    msg.includes('out of stock') ||
    msg.includes('sold out') ||
    (msg.includes('only') && msg.includes('available')) ||
    msg.includes('inventory') ||
    msg.includes('cannot add') ||
    msg.includes('exceeds')
  );
}

// Core add-to-cart (returns data, no UI) — single API call
async function addToCartCore(variantId, quantity = 1) {
  const numericVariantId = parseInt(variantId, 10);

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: numericVariantId, quantity: quantity })
  });

  if (!response.ok) {
    var errorMsg = 'Failed to add to cart';
    try {
      var errorData = await response.json();
      errorMsg = errorData.description || errorData.message || errorMsg;
    } catch(e) {}
    throw new Error(errorMsg);
  }

  const addedItem = await response.json();

  return {
    success: true,
    item: addedItem,
    requested: quantity,
    wasCapped: false
  };
}

/**
 * UNIFIED ADD TO CART HANDLER
 * Use this everywhere - cart page, wishlist, product page, quick view, etc.
 * 
 * @param {Object} options
 * @param {string|number} options.variantId - Shopify variant ID
 * @param {number} options.quantity - Quantity to add (default: 1)
 * @param {string} options.productTitle - Product name for error messages
 * @param {HTMLElement|jQuery} options.button - Button element (optional)
 * @param {Object} options.buttonStates - Custom button text states (optional)
 * @param {boolean} options.showSuccessToast - Show success toast (default: true)
 */
async function addToCart(options) {
  const {
    variantId,
    quantity = 1,
    productTitle = 'This item',
    button = null,
    buttonStates = {},
    showSuccessToast = true
  } = options;
  
  // Default button states
  const states = {
    loading: buttonStates.loading || 'Adding...',
    success: buttonStates.success || 'Added ✓',
    soldOut: buttonStates.soldOut || 'Sold Out',
    ...buttonStates
  };
  
  // Normalize button to jQuery (if provided)
  const $btn = button ? (button.jquery ? button : $(button)) : null;
  const btnEl = $btn ? $btn[0] : null;
  
  // Store original state
  let originalText = '';
  let originalDisabled = false;
  
  if (btnEl) {
    originalText = btnEl.textContent || btnEl.innerText;
    originalDisabled = btnEl.disabled;
    
    // Set loading state
    btnEl.disabled = true;
    btnEl.classList.add('loading');
    btnEl.textContent = states.loading;
  }
  
  try {
    const result = await addToCartCore(variantId, quantity);
    
    // STOCK WAS CAPPED
    if (result.wasCapped) {
      let errorMessage;
      
      if (result.addedQty <= 0) {
        errorMessage = `You already have the maximum available quantity in your cart.`;
      } else {
        errorMessage = `Only ${result.addedQty} could be added. You now have ${result.actualTotal} in your cart.`;
      }
      
      // Show error toast
      if (window.cartDrawerTabs) {
        window.cartDrawerTabs.showError(
          `<strong>${productTitle}</strong><br>${errorMessage}`,
          'Stock Limit Reached',
          'error'
        );
      }
      
      // Update cart UI
      if (typeof theme !== 'undefined' && theme.miniCart) {
        await generateCartAsync();
      }

      // Reset button
      if (btnEl) {
        btnEl.disabled = originalDisabled;
        btnEl.classList.remove('loading');
        btnEl.textContent = originalText;
      }

      return { success: false, capped: true, ...result };
    }

    // FULL SUCCESS
    if (showSuccessToast && window.cartDrawerTabs) {
      window.cartDrawerTabs.showError(
        `<strong>${productTitle}</strong> added to your bag!`,
        'Added to Cart',
        'success'
      );
    }

    if (typeof theme !== 'undefined' && theme.miniCart) {
      await generateCartAsync();
    }
    
    // Success state on button
    if (btnEl) {
      btnEl.classList.remove('loading');
      btnEl.classList.add('added');
      btnEl.textContent = states.success;
      
      // Reset after delay
      setTimeout(() => {
        btnEl.classList.remove('added');
        btnEl.disabled = originalDisabled;
        btnEl.textContent = originalText;
      }, 2000);
    }
    
    return { success: true, capped: false, ...result };
    
  } catch (error) {
    const stockError = isStockError(error.message);
    
    // Show error toast
    if (window.cartDrawerTabs) {
      window.cartDrawerTabs.showError(
        `<strong>${productTitle}</strong><br>${error.message}`,
        stockError ? 'Out of Stock' : 'Cannot Add to Cart',
        'error'
      );
    }
    
    // Update button state
    if (btnEl) {
      btnEl.classList.remove('loading');
      
      if (stockError) {
        btnEl.classList.add('unavailable');
        btnEl.textContent = states.soldOut;
        btnEl.disabled = true;
      } else {
        btnEl.disabled = originalDisabled;
        btnEl.textContent = originalText;
      }
    }
    
    return { success: false, error: error.message, isStockError: stockError };
  }
}

// ============================================================================
// END UNIFIED ADD TO CART
// ============================================================================

// Cart Item Builder - builds HTML for a single cart item
function buildCartItem(product, appliedCodes, wishlist) {
  const itemKey = product.key;
  const productTitle = product.product_title || product.title;
  const displayTitle = product.product_title || product.title;
  const originalLinePrice = product.original_line_price;
  const finalLinePrice = product.final_line_price;
  const quantity = product.quantity;

  // Line totals (quantity × price)
  const originalLinePriceFormatted = theme.Currency.formatMoney(originalLinePrice, theme.moneyFormat);
  const finalLinePriceFormatted = theme.Currency.formatMoney(finalLinePrice, theme.moneyFormat);

  const hasDiscount = originalLinePrice > finalLinePrice;
  const variantTitle = product.variant_title || '';
  const itemDiscounts = product.line_level_discount_allocations || [];

  theme.GiftWrap.hideGift(product.id);

  let html = `<div class="mcart-item" data-item-key="${itemKey}" data-product-title="${productTitle}">`;

  // Image (circular via CSS)
  html += buildCartItemImage(product);

  // Details — title row has title + (price stacked over qty pill, top-right),
  // variants flow underneath the title, Remove sits bottom-right.
  html += `  <div class="mcart-details">`;
  html += `    <div class="mcart-title-row">`;
  html += `      <div class="mcart-title"><a href="${product.url}">${displayTitle}</a></div>`;
  html += `      <div class="mcart-title-rt">`;
  html += buildLinePrice(hasDiscount, finalLinePriceFormatted, originalLinePriceFormatted);
  html += buildQuantityControls(itemKey, productTitle, product.quantity);
  html += `      </div>`;
  html += `    </div>`;

  const variants = (product.options_with_values || []).filter(function(opt) {
    return opt && opt.name && opt.value && opt.name !== 'Title' && opt.value !== 'Default Title';
  });
  if (variants.length > 0) {
    variants.forEach(function(opt) {
      html += `    <div class="mcart-variant">${opt.name}: ${opt.value}</div>`;
    });
  } else if (variantTitle) {
    html += `    <div class="mcart-variant">${variantTitle}</div>`;
  }

  // Remove anchored at bottom-right of the details column
  html += `    <div class="mcart-actions-row">`;
  html += buildRemoveButton(itemKey);
  html += `    </div>`;

  html += buildInlineDiscountBadge(itemDiscounts, appliedCodes, hasDiscount);
  html += `  </div>`;

  // Error container
  html += `  <div class="mcart-error" style="display: none;">`;
  html += `    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`;
  html += `    <span class="mcart-error-msg"></span>`;
  html += `  </div>`;

  html += `</div>`;

  return html;
}

// Build cart item image section
function buildCartItemImage(product) {
  return `
  <div class="mcart-img">
    <a href="${product.url}">
      <img src="${product.image}&width=160" alt="${product.title}"/>
    </a>
  </div>`;
}


function buildInlineDiscountBadge(itemDiscounts, appliedCodes, hasDiscount) {
  if (itemDiscounts.length > 0) {
    return itemDiscounts.map(discount => 
      `<div class="mcart-discount-badge-inline">
        <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>
        ${discount.discount_application.title}
      </div>`
    ).join('');
  } else if (appliedCodes.length > 0 && hasDiscount) {
    return `<div class="mcart-discount-badge-inline">
      <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>
      ${appliedCodes[0]}
    </div>`;
  }
  return '';
}


// Build line price display (total for this line item)
function buildLinePrice(hasDiscount, finalLinePriceFormatted, originalLinePriceFormatted) {
  let html = `      <div class="mcart-price">`;
  if (hasDiscount) {
    html += `        <span class="mcart-price-final">${finalLinePriceFormatted}</span>`;
    html += `        <span class="mcart-price-old">${originalLinePriceFormatted}</span>`;
  } else {
    html += `        <span class="mcart-price-final">${finalLinePriceFormatted}</span>`;
  }
  html += `      </div>`;
  return html;
}

// Build quantity controls — plain text minus/plus
function buildQuantityControls(itemKey, productTitle, quantity) {
  return `
      <div class="mcart-qty">
        <button type="button" class="mcart-qty-btn js-qty__minus" data-key="${itemKey}" data-title="${productTitle}" aria-label="Decrease quantity">&minus;</button>
        <input type="text" class="mcart-qty-input js-qty__input" data-key="${itemKey}" data-title="${productTitle}" data-current-qty="${quantity}" value="${quantity}" aria-label="Quantity" readonly/>
        <button type="button" class="mcart-qty-btn js-qty__plus" data-key="${itemKey}" data-title="${productTitle}" aria-label="Increase quantity">+</button>
      </div>`;
}

// Build remove button — inline coral text link
function buildRemoveButton(itemKey) {
  return `    <button class="mcart-remove js-remove-mini-cart" data-key="${itemKey}" title="Remove" aria-label="Remove item">Remove</button>`;
}

// Update cart totals display - FIXED for empty cart
function updateCartTotals(cart) {
  const originalTotal = cart.original_total_price || cart.total_price || 0;
  const finalTotal = cart.total_price || 0;
  const itemCount = cart.item_count || 0;

  // Prefer cart.total_discount (line-level allocations) — it already includes
  // cart-level discounts that get allocated to line items, so summing both
  // double-counts. Only fall back to cart_level applications when total_discount
  // is zero (rare cases where a cart-level app doesn't allocate to lines).
  var totalDiscount = cart.total_discount || 0;
  if (totalDiscount === 0 && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
    cart.cart_level_discount_applications.forEach(function(app) {
      totalDiscount += (app.total_allocated_amount || 0);
    });
  }

  const formattedTotal = theme.Currency.formatMoney(finalTotal, theme.moneyFormat);
  const formattedSubtotal = theme.Currency.formatMoney(originalTotal, theme.moneyFormat);

  $(cartTotal).html(formattedTotal);
  $('.js-cart-count-title').text(itemCount);

  if (itemCount === 0) {
    const zeroFormatted = theme.Currency.formatMoney(0, theme.moneyFormat);
    $('.js-cart-subtotal').html(zeroFormatted);
    $('.js-cart-total').html(zeroFormatted);
    $('.js-cart-discount-row').hide();
    $('.js-cart-discount').html('-' + zeroFormatted);
    $('.js-cart-discount-pct').empty();
    return;
  }

  if (totalDiscount > 0) {
    $('.js-cart-subtotal').html(formattedSubtotal);
    $('.js-cart-discount-row').show();
    var pctLabel = '';
    var baseTotal = originalTotal || (finalTotal + totalDiscount);
    if (baseTotal > 0) {
      var pct = Math.round((totalDiscount / baseTotal) * 100);
      if (pct > 0) {
        pctLabel = ' <small class="js-cart-discount-percent">(' + pct + '% off)</small>';
      }
    }
    $('.js-cart-discount-pct').html(pctLabel);
    $('.js-cart-discount').html('-' + theme.Currency.formatMoney(totalDiscount, theme.moneyFormat));
  } else {
    // Check for saved codes that only resolve at checkout
    var savedCodes = [];
    try {
      var codesRaw = localStorage.getItem('appliedDiscountCodes');
      savedCodes = codesRaw ? JSON.parse(codesRaw) : [];
    } catch (e) {}

    $('.js-cart-subtotal').html(formattedTotal);
    $('.js-cart-discount-pct').empty();
    if (savedCodes.length > 0) {
      $('.js-cart-discount-row').show();
      $('.js-cart-discount').html('<small class="js-cart-discount-pending">Applied at checkout</small>');
    } else {
      $('.js-cart-discount-row').hide();
    }
  }
}

// Update checkout button with discount codes
function updateCheckoutButton(appliedCodes) {
  if (appliedCodes.length > 0) {
    const discountParam = appliedCodes.join(',');
    $('.js-cart-btn-checkout').attr('href', '/checkout?discount=' + encodeURIComponent(discountParam));
  } else {
    $('.js-cart-btn-checkout').attr('href', '/checkout');
  }
}

// Attach wishlist event handlers (works with both old positioned hearts and new inline buttons)
function attachWishlistHandlers(cartContent) {
  $(cartContent).find('.mcart-wishlist-heart, .mcart-wishlist-inline').off('click').on('click', function(){
    const $heart = $(this);
    const handle = $heart.attr('data-handle');
    let wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [];
    
    if ($heart.hasClass('wishlisted')) {
      // Remove from wishlist
      wishlist = wishlist.filter(h => h !== handle);
      $heart.removeClass('wishlisted');
      $heart.find('svg').attr('fill', 'none');
      $heart.attr('title', 'Add to wishlist');
      
      // Update text if inline button
      if ($heart.hasClass('mcart-wishlist-inline')) {
        $heart.find('span').text('Add to wishlist');
      }
    } else {
      // Add to wishlist
      wishlist.push(handle);
      $heart.addClass('wishlisted');
      $heart.find('svg').attr('fill', 'currentColor');
      $heart.attr('title', 'Remove from wishlist');
      
      // Update text if inline button
      if ($heart.hasClass('mcart-wishlist-inline')) {
        $heart.find('span').text('In wishlist');
      }
    }
    
    localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    
    if (typeof $ !== 'undefined') {
      $('.js-wishlist-count').text(wishlist.length);
    }
  });
}

// Debounced quantity change — collects rapid clicks into one request
var _qtyChangeTimers = {};
var _qtyChangeLock = {};
var _qtyPendingValue = {};

// Global cart-pending lock (qty changes + removes) — disables checkout + shows spinner on totals
var _cartPendingCount = 0;
function setCartPending(isPending) {
  if (isPending) {
    _cartPendingCount++;
  } else {
    _cartPendingCount = Math.max(0, _cartPendingCount - 1);
  }
  var pending = _cartPendingCount > 0;
  var $totals = $('.js-cart-subtotal, .js-cart-total, .js-cart-discount');
  $totals.toggleClass('is-cart-loading', pending);
  var $checkout = $('.js-cart-btn-checkout');
  if (pending) {
    $checkout.addClass('is-cart-disabled').attr('aria-busy', 'true').attr('aria-disabled', 'true');
  } else {
    $checkout.removeClass('is-cart-disabled').removeAttr('aria-busy').removeAttr('aria-disabled');
  }
}

function debouncedQuantityChange(itemKey, productTitle, newVal, $item) {
  // Update the displayed value immediately for responsiveness
  var $input = $item.find('.js-qty__input');
  $input.attr('data-current-qty', newVal);
  $input.val(newVal);

  // Clear any pending timer for this item
  if (_qtyChangeTimers[itemKey]) clearTimeout(_qtyChangeTimers[itemKey]);

  // If a request is in-flight, queue the latest value — it will fire after the current one finishes
  if (_qtyChangeLock[itemKey]) {
    _qtyPendingValue[itemKey] = { productTitle: productTitle, newVal: newVal, $item: $item };
    return;
  }

  // Debounce: wait 800ms after last click before sending request
  _qtyChangeTimers[itemKey] = setTimeout(function() {
    delete _qtyChangeTimers[itemKey];
    handleQuantityChangeAsync(itemKey, productTitle, newVal, $item);
  }, 800);
}

// ASYNC: Handle quantity change with modern fetch
async function handleQuantityChangeAsync(itemKey, productTitle, newVal, $item) {
  _qtyChangeLock[itemKey] = true;
  setCartPending(true);

  $item.find('.mcart-error').slideUp(200, 'linear');

  // Add loading state
  const $buttons = $item.find('.mcart-qty-btn');
  $buttons.prop('disabled', true).addClass('loading');

  try {
    // Update cart asynchronously and get the cart response
    const cart = await updateCartItemQuantity(itemKey, newVal);

    // Find the actual item in the cart response
    const actualItem = cart.items.find(item => item.key === itemKey);
    const actualQuantity = actualItem ? actualItem.quantity : 0;

    // Re-enable buttons
    $buttons.prop('disabled', false).removeClass('loading');

    // Check if quantity was adjusted due to stock limits
    if (actualQuantity !== newVal && actualQuantity > 0) {
      const errorMessage = `Only ${actualQuantity} items available.`;
      const fullMessage = `<strong>${productTitle}</strong><br>${errorMessage}`;

      if (window.cartDrawerTabs) {
        window.cartDrawerTabs.showError(fullMessage, 'Stock Limit Reached');
      }
    }

    // Only regenerate cart if no more pending changes queued
    if (!_qtyPendingValue[itemKey]) {
      if (typeof theme !== 'undefined' && theme.miniCart) {
        await generateCartAsync();
      }
    }
  } catch (error) {
    // Re-enable buttons
    $buttons.prop('disabled', false).removeClass('loading');

    const errorMessage = error.message || 'Unable to update cart';
    const fullMessage = `<strong>${productTitle}</strong><br>${errorMessage}`;

    if (window.cartDrawerTabs) {
      window.cartDrawerTabs.showError(fullMessage, newVal === 0 ? 'Cannot Update Quantity' : 'Stock Limit Reached');
    }

    // Only regenerate if no pending changes
    if (!_qtyPendingValue[itemKey]) {
      setTimeout(async () => {
        if (typeof theme !== 'undefined' && theme.miniCart) {
          await generateCartAsync();
        }
      }, 1500);
    }
  } finally {
    delete _qtyChangeLock[itemKey];
    setCartPending(false);

    // If clicks came in while we were busy, process the latest one now
    if (_qtyPendingValue[itemKey]) {
      const pending = _qtyPendingValue[itemKey];
      delete _qtyPendingValue[itemKey];
      debouncedQuantityChange(itemKey, pending.productTitle, pending.newVal, pending.$item);
    }
  }
}

// Attach quantity button event handlers
function attachQuantityHandlers(cartContent) {
  // Minus button
  $(cartContent).find(".js-qty__minus").off('click').on('click', function(){
    const $input = $(this).siblings('.js-qty__input');
    const currentVal = parseInt($input.attr('data-current-qty')) || 0;
    const itemKey = $input.attr('data-key');
    const productTitle = $input.attr('data-title');
    const newVal = Math.max(0, currentVal - 1);
    const $item = $(this).closest('.mcart-item');

    debouncedQuantityChange(itemKey, productTitle, newVal, $item);
  });

  // Plus button
  $(cartContent).find(".js-qty__plus").off('click').on('click', function(){
    const $input = $(this).siblings('.js-qty__input');
    const currentVal = parseInt($input.attr('data-current-qty')) || 0;
    const itemKey = $input.attr('data-key');
    const productTitle = $input.attr('data-title');
    const newVal = currentVal + 1;
    const $item = $(this).closest('.mcart-item');

    debouncedQuantityChange(itemKey, productTitle, newVal, $item);
  });
}

// ASYNC: Attach remove button event handlers - COMPLETELY FIXED
function attachRemoveHandlers(cartContent) {
  $(cartContent).find('.js-remove-mini-cart').off('click').on('click', async function(e){
    e.preventDefault();
    e.stopPropagation(); // IMPORTANT: Stop legacy handler from firing
    
    const $button = $(this);
    const itemKey = $button.attr('data-key');
    const $item = $button.closest('.mcart-item');
    const productTitle = $item.attr('data-product-title') || 'this item';
    
    // Prevent double-click
    if ($button.data('removing')) return;
    $button.data('removing', true);
    $button.prop('disabled', true);
    setCartPending(true);

    try {
      // Start animation immediately — don't wait for API
      const itemHeight = $item.outerHeight(true);
      $item.css({
        'overflow': 'hidden',
        'height': itemHeight + 'px'
      });
      // Force reflow
      $item[0].offsetHeight;
      // Phase 1: fade out + slide
      $item.css({
        'transition': 'opacity 0.2s ease, transform 0.2s ease',
        'opacity': '0',
        'transform': 'scale(0.96) translateX(-20px)'
      });

      // Fire API call in parallel
      const apiPromise = updateCartItemQuantity(itemKey, 0);

      // Phase 2: after fade completes, collapse height
      await new Promise(resolve => setTimeout(resolve, 220));
      $item.css({
        'transition': 'height 0.2s ease, margin-bottom 0.2s ease',
        'height': '0px',
        'margin-bottom': '0px'
      });

      // Wait for collapse + API to both finish
      await Promise.all([
        apiPromise,
        new Promise(resolve => setTimeout(resolve, 220))
      ]);

      // Both done — refresh cart
      if (typeof theme !== 'undefined' && theme.miniCart) {
        await generateCartAsync();
      }
      
    } catch (error) {
      // Re-enable button
      $button.prop('disabled', false).css('opacity', '1');
      
      const errorMessage = error.message || 'Unable to remove item';
      
      if (window.cartDrawerTabs) {
        window.cartDrawerTabs.showError(`<strong>${productTitle}</strong><br>${errorMessage}`, 'Cannot Remove Item');
      } else {
        const $error = $item.find('.mcart-error');
        $error.find('.mcart-error-msg').html(errorMessage);
        $error.slideDown(200, 'linear');
        
        setTimeout(() => {
          $error.slideUp(200, 'linear');
        }, 3000);
      }
      
      // Refresh cart after error
      setTimeout(() => {
        if (typeof theme !== 'undefined' && theme.miniCart) {
          generateCartAsync();
        }
      }, 2000);
    } finally {
      setCartPending(false);
    }
  });
}

// ASYNC: Main cart generation function - much faster with async/await
async function generateCartAsync() {
  try {
    // Fetch cart data once — shared by all updates
    const cart = await getCartData();

    let htmlCart = cart.item_count === 0 ? emptyCartHTML : '';
    const itemCount = cart.items.length;

    // Get data from localStorage (synchronous, very fast)
    const appliedCodes = JSON.parse(localStorage.getItem('appliedDiscountCodes')) || [];
    const wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [];

    // Build cart items HTML
    for (let i = 0; i < itemCount; i++) {
      htmlCart += buildCartItem(cart.items[i], appliedCodes, wishlist);
    }

    // Update totals, counts, free shipping — pass cart data to avoid extra /cart.js fetch
    updateCartTotals(cart);
    updateElements(cart);

    // Update checkout button
    updateCheckoutButton(appliedCodes);

    // Update DOM + attach handlers in one paint frame to prevent flash
    requestAnimationFrame(function() {
      $(cartContent).html(htmlCart);
      attachWishlistHandlers(cartContent);
      attachQuantityHandlers(cartContent);
      attachRemoveHandlers(cartContent);
    });
  } catch (error) {
    console.error('Error generating cart:', error);
    if (window.cartDrawerTabs) {
      window.cartDrawerTabs.showError('Unable to load cart. Please refresh the page.', 'Cart Error');
    }
  }
}

// LEGACY: Wrapper for backward compatibility with callback-based code
function generateCart(callback) {
  generateCartAsync().then(() => {
    if (typeof callback === 'function') {
      callback();
    }
  }).catch(error => {
    console.error('Cart generation error:', error);
    if (typeof callback === 'function') {
      callback(error);
    }
  });
}

//Keep popup when click cart / UX
$(document).on('click',cartToggle,function(){
  var $cart = $(this).parent(miniCart);
  var isOpening = !$cart.hasClass('active');
  if (isOpening) $cart.addClass('cart-opening');
  $cart.toggleClass('active');
  if (isOpening) {
    setTimeout(function() { $cart.removeClass('cart-opening'); }, 550);
  }
});
$(document).on('click','.overlaycart, .close',function(){
  $(this).parents(miniCart).removeClass('active');
});

// gen minicart when load page
generateCart();
return {
  updateElements: updateElements,
  generateCart: generateCart,
  generateCartAsync: generateCartAsync,
  addToCart: addToCart,
  isStockError: isStockError
}
})()

// ============================================================================
// END || ASYNC CART FUNCTIONS - Much faster with modern async/await
// ============================================================================

// Free shipping
theme.freeShipping = (function(){
  var $freeShippingClass = $('.js-free-shipping'),
      $freeShippingTextClass = $('.js-free-shipping-text'),
      $free_fisrt = $freeShippingClass.attr('data-start'),
      $free_end = $freeShippingClass.attr('data-end')
      minOrderValue = parseInt($freeShippingClass.data('value')) || 0,
      $percentClass = $('.js-free-shipping .progress-bar');

  function generate(cart){
    var priceCart = cart.total_price;
    var $percentLabel = $('.js-free-shipping-percent');
    var $freeShippingWrap = $('.free-shipping');
    var $subtextEl = $('.js-free-shipping-subtext');
    var $cartShipping = $('.js-cart-shipping');
    priceCart == 0 ? $freeShippingWrap.hide() : $freeShippingWrap.show();
    if (priceCart >= minOrderValue && minOrderValue > 0){
      $percentClass.css('width','100%').removeClass('progress-bar-striped bg-primary');
      $freeShippingTextClass.html("You've unlocked <strong>Free Shipping!</strong>");
      $percentLabel.text('100%');
      $subtextEl.hide();
      $cartShipping.text('Free').addClass('is-free');
    }else{
      let percent = Math.round(priceCart / minOrderValue * 100);
      let left = Shopify.formatMoney((minOrderValue - priceCart),theme.moneyFormat);
      $percentClass.css('width',percent+'%').addClass('progress-bar-striped primary');
      $freeShippingTextClass.html(left + ' away from <strong>Free Shipping</strong>');
      $percentLabel.text(percent + '%');
      $subtextEl.show();
      $cartShipping.text('Calculated at checkout').removeClass('is-free');
    }
  }

  return {
    load:generate
  }
})()

// Shipping time - https://github.com/phstc/jquery-dateFormat
theme.shippingTime = (function(){
  var $shippingTime = $('.js-shipping-time'),
      shippingTime = $shippingTime.data('time') || '',
      now = new Date(),
      restHour = 23 - now.getHours(),
      restMinute = 59 - now.getMinutes();
  if (shippingTime !== ''){
    var nextTime = new Date(now.getTime() + shippingTime * 86400000),
        formatTime = $.format.date(nextTime, "ddd, dd MMMM yyyy"),
        htmlShipping = 'Order in the next <b>'+restHour+'</b> hours <b>'+restMinute+'</b> minutes to get it by <b>'+formatTime+'</b>. ';
    $shippingTime.html(htmlShipping);
  }
})()




// Wishlist
theme.wishlist = (function () {
  const btnWishlist = '.js-btn-wishlist',
        btnRemoveWishlist = '.js-remove-wishlist',
        $wishlistCount = $('.js-wishlist-count'),
        $wishlistContainer = $('.js-wishlist-content'),
        wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [],
        wishlistPageUrl = $('.js-wishlist-link').attr('href');

  function showNoResult() {
    $wishlistContainer.html(`
      <div class="era-wishlist__empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
        <p class="era-wishlist__empty-title">Nothing here yet</p>
        <p class="era-wishlist__empty-text">Start adding pieces you love and build your dream lineup.</p>
        <a href="/collections/all" class="era-wishlist__empty-cta">EXPLORE COLLECTION</a>
      </div>
    `);
  }

  function updateWishlist(self) {
    const productHandle = $(self).data('handle');
    const allSimilarProducts = $(`${btnWishlist}[data-handle="${productHandle}"]`);
    const isAdded = wishlist.includes(productHandle);

    if (isAdded) {
      wishlist.splice(wishlist.indexOf(productHandle), 1);
      allSimilarProducts.html(`${theme.strings.wishlistIcon}${theme.strings.wishlistText}`);
      allSimilarProducts.attr('data-original-title', theme.strings.wishlistText);
      allSimilarProducts.removeClass('added');
    } else {
      wishlist.push(productHandle);
      allSimilarProducts.fadeOut('slow').fadeIn('fast').html(`${theme.strings.wishlistIconAdded}${theme.strings.wishlistTextAdded}`);
      allSimilarProducts.attr('data-original-title', theme.strings.wishlistTextAdded);
      allSimilarProducts.addClass('added');
      $('.tooltip-inner').text(theme.strings.wishlistTextAdded);
    }

    localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    $wishlistCount.text(wishlist.length);
  }

  function getVariantLabel(product) {
    var v = product.variants[0];
    if (!v) return '';
    var parts = [];
    // Only include color-type options, skip everything else
    var colorNames = ['color', 'colors', 'colour', 'colours', 'material', 'style'];
    if (product.options && product.options.length > 0) {
      for (var oi = 0; oi < product.options.length; oi++) {
        var opt = product.options[oi];
        var optName = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
        if (colorNames.indexOf(optName) === -1) continue;
        var val = v.options ? v.options[oi] : '';
        if (val && val !== 'Default Title') {
          parts.push(val);
        }
      }
    }
    return parts.join(' / ');
  }

  function buildSizeButtons(product) {
    // Find the size option index
    var sizeIndex = -1;
    if (product.options) {
      for (var i = 0; i < product.options.length; i++) {
        var opt = product.options[i];
        var optName = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
        if (optName === 'size' || optName === 'sizes') {
          sizeIndex = i;
          break;
        }
      }
    }

    // If no size option or only default variant, return a single ATC button with the first variant
    if (sizeIndex === -1 || (product.variants.length === 1 && product.variants[0].title === 'Default Title')) {
      var v = product.variants[0];
      if (!v || !v.available) return '<button class="era-wishlist__atc era-wishlist__atc--sold-out" disabled>SOLD OUT</button>';
      return '<button class="era-wishlist__atc js-wishlist-atc" data-variant-id="' + v.id + '">ADD TO CART</button>';
    }

    // Collect unique size values and their variant info
    var sizes = [];
    var seen = {};
    for (var vi = 0; vi < product.variants.length; vi++) {
      var variant = product.variants[vi];
      var sizeVal = variant.options ? variant.options[sizeIndex] : null;
      if (sizeVal && !seen[sizeVal]) {
        seen[sizeVal] = true;
        sizes.push({
          label: sizeVal,
          variantId: variant.id,
          available: variant.available
        });
      }
    }

    var html = '<div class="era-wishlist__sizes">';
    for (var si = 0; si < sizes.length; si++) {
      var s = sizes[si];
      html += '<button class="era-wishlist__size-btn js-wl-size-btn' + (s.available ? '' : ' unavailable') + '" ' +
        'data-variant-id="' + s.variantId + '" ' +
        (s.available ? '' : 'disabled') + '>' +
        s.label + '</button>';
    }
    html += '</div>';
    return html;
  }

  function getCollectionType(product) {
    // Use product type or vendor as the "collection tag" above the title
    return product.type || product.vendor || '';
  }

  function reindexCards(animate) {
    var $cards = $wishlistContainer.children('.era-wishlist__card');
    $cards.each(function(i) {
      var $card = $(this);
      var shouldReverse = (i % 2 === 1);
      var isReverse = $card.hasClass('era-wishlist__card--reverse');

      if (shouldReverse !== isReverse) {
        if (animate) {
          // Phase 1: slide out to the side
          var swapClass = shouldReverse ? 'era-wishlist__card--swap-to-reverse' : 'era-wishlist__card--swap-to-normal';
          $card.addClass('era-wishlist__card--transitioning ' + swapClass);

          // Phase 2: after slide out, flip the class and slide back in
          setTimeout(function() {
            $card.toggleClass('era-wishlist__card--reverse', shouldReverse);
            $card.removeClass(swapClass);
            // Force reflow so the transition plays the return
            $card[0].offsetHeight;
            setTimeout(function() {
              $card.removeClass('era-wishlist__card--transitioning');
            }, 500);
          }, 300);
        } else {
          $card.toggleClass('era-wishlist__card--reverse', shouldReverse);
        }
      }
    });
  }

  function handleWishlistAddToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var $btn = $(btn);
    $btn.prop('disabled', true).text('ADDING...');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) { throw data; });
      }
      return response.json();
    })
    .then(function(data) {
      $btn.text('ADDED!');
      theme.toast.show('Added to cart!', 'success');
      // generateCart already fetches /cart.js and updates counts + free shipping
      if (theme.miniCart && theme.miniCart.generateCart) theme.miniCart.generateCart();
      setTimeout(function() {
        $btn.prop('disabled', false).text('ADD TO CART');
      }, 2000);
    })
    .catch(function(err) {
      var msg = (err && err.description) ? err.description : 'Could not add to cart';
      theme.toast.show(msg, 'error');
      $btn.prop('disabled', false).text('ADD TO CART');
    });
  }

  var wishlistObserver = null;

  function observeCards() {
    if (wishlistObserver) wishlistObserver.disconnect();
    if (!('IntersectionObserver' in window)) {
      // Fallback: reveal all immediately
      $wishlistContainer.find('.era-wishlist__card').addClass('era-wishlist__card--visible');
      return;
    }
    wishlistObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('era-wishlist__card--visible');
          wishlistObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    $wishlistContainer.find('.era-wishlist__card').each(function() {
      if (!this.classList.contains('era-wishlist__card--visible')) {
        wishlistObserver.observe(this);
      }
    });
  }

  function loadWishlist() {
    $wishlistContainer.empty();
    var $footer = $('.js-wishlist-footer');
    $footer.hide();

    if (wishlist.length > 0) {
      var loadedCount = 0;
      var subtotal = 0;

      wishlist.forEach(function(productHandle, index) {
        jQuery.getJSON(window.Shopify.routes.root + 'products/' + productHandle + '.js', function(product) {
          var productPrice = theme.Currency.formatMoney(product.price, theme.moneyFormat);
          var productComparePrice = product.compare_at_price_min !== 0
            ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat)
            : '';
          var hasSale = productComparePrice && product.compare_at_price_min > product.price;
          var collectionType = getCollectionType(product);
          var variantLabel = getVariantLabel(product);
          var sizeButtonsHtml = buildSizeButtons(product);
          var imageUrl = product.featured_image || '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693571571c306f858ee8f71.gif';
          subtotal += product.price;

          var htmlProduct = '<div class="era-wishlist__card js-wishlist-item" data-handle="' + product.handle + '" style="animation-delay:' + (loadedCount * 80) + 'ms">' +
            '<div class="era-wishlist__card-line"></div>' +
            '<div class="era-wishlist__card-inner">' +
              '<div class="era-wishlist__card-image-wr">' +
                '<a href="' + product.url + '" class="era-wishlist__card-image">' +
                  '<img src="' + imageUrl + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' +
                '</a>' +
                '<button class="era-wishlist__remove js-remove-wishlist" data-handle="' + product.handle + '" aria-label="Remove from wishlist">Remove from wishlist</button>' +
              '</div>' +
              '<div class="era-wishlist__card-info">' +
                (collectionType ? '<span class="era-wishlist__card-type">' + collectionType.toUpperCase() + '</span>' : '') +
                '<h2 class="era-wishlist__card-title"><a href="' + product.url + '">' + product.title.toUpperCase() + '</a></h2>' +
                '<div class="era-wishlist__card-price-row">' +
                  (variantLabel ? '<span class="era-wishlist__card-variant">' + variantLabel + '</span>' : '') +
                  '<span class="era-wishlist__card-price">' +
                    (hasSale ? '<span class="era-wishlist__card-price--sale">' + productPrice + '</span><s class="era-wishlist__card-price--compare">' + productComparePrice + '</s>' : productPrice) +
                  '</span>' +
                '</div>' +
                '<div class="era-wishlist__card-actions">' +
                  sizeButtonsHtml +
                '</div>' +
                '<div class="era-wishlist__qty-slot"></div>' +
              '</div>' +
            '</div>' +
          '</div>';

          var $newCard = $(htmlProduct);
          $wishlistContainer.append($newCard);

          // Assign alternating direction based on DOM position
          var domIndex = $wishlistContainer.children('.era-wishlist__card').index($newCard);
          if (domIndex % 2 === 1) {
            $newCard.addClass('era-wishlist__card--reverse');
          }

          // Observe this card for scroll reveal
          if (wishlistObserver) {
            wishlistObserver.observe($newCard[0]);
          }

          loadedCount++;
          if (loadedCount === wishlist.length) {
            // Show subtotal
            $('.js-wishlist-subtotal').text(theme.Currency.formatMoney(subtotal, theme.moneyFormat));
            $footer.show();
            // Re-assign directions in case async order was wrong
            reindexCards();
            // Start observing all cards
            observeCards();
          }
        }).fail(function() {
          loadedCount++;
        });
      });
    } else {
      showNoResult();
    }

    $wishlistCount.text(wishlist.length);

    $(btnWishlist).each(function () {
      const productHandle = $(this).data('handle');
      const isProductAdded = wishlist.includes(productHandle);
      const iconWishlist = isProductAdded ? theme.strings.wishlistIconAdded : theme.strings.wishlistIcon;
      const textWishlist = isProductAdded ? theme.strings.wishlistTextAdded : theme.strings.wishlistText;

      $(this).html(`${iconWishlist}${textWishlist}`).attr('title', textWishlist);
      $(this).toggleClass('added', isProductAdded);
    });
  }

  $(document).on('click', btnWishlist, function (event) {
    event.preventDefault();
    updateWishlist(this);
  });

  // Wishlist size button → show qty picker
  $(document).on('click', '.js-wl-size-btn', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var $btn = $(this);
    if ($btn.prop('disabled')) return;

    var variantId = $btn.data('variant-id');
    if (!variantId) return;

    var $card = $btn.closest('.era-wishlist__card');
    var $slot = $card.find('.era-wishlist__qty-slot');

    // Highlight selected size
    $card.find('.js-wl-size-btn').removeClass('selected');
    $btn.addClass('selected');

    // Fetch cart to check if variant already in cart
    var sizeName = $btn.text().trim();
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartQty = 0;
        var numericId = parseInt(variantId);
        cart.items.forEach(function(item) {
          if (item.variant_id === numericId || item.id === numericId) {
            cartQty = item.quantity;
          }
        });

        var isUpdate = cartQty > 0;
        var btnLabel = isUpdate ? 'UPDATE CART' : 'ADD TO CART';
        var startQty = isUpdate ? cartQty : 1;

        var pickerHtml = '<div class="era-wishlist__qty-picker" data-variant-id="' + variantId + '" data-mode="' + (isUpdate ? 'update' : 'add') + '" data-cart-qty="' + cartQty + '">' +
          (isUpdate ? '<span class="era-wishlist__qty-badge">' + cartQty + ' in cart</span>' : '') +
          '<div class="era-wishlist__qty-row">' +
            '<div class="era-wishlist__qty-controls">' +
              '<button type="button" class="era-wishlist__qty-btn js-wl-qty-minus">&minus;</button>' +
              '<input type="text" class="era-wishlist__qty-input js-wl-qty-value" value="' + startQty + '" data-min="' + (isUpdate ? '0' : '1') + '" data-max="99" readonly>' +
              '<button type="button" class="era-wishlist__qty-btn js-wl-qty-plus">&plus;</button>' +
            '</div>' +
            '<button type="button" class="era-wishlist__atc js-wl-qty-atc">' + btnLabel + '</button>' +
          '</div>' +
        '</div>';

        $slot.html(pickerHtml);
      });
  });

  // Wishlist qty +/- buttons
  $(document).on('click', '.js-wl-qty-minus, .js-wl-qty-plus', function(event) {
    event.preventDefault();
    event.stopPropagation();
    var $this = $(this);
    var picker = this.closest('.era-wishlist__qty-picker');
    if (!picker) return;
    var $input = $(picker).find('.js-wl-qty-value');
    var val = parseInt($input.val()) || 0;
    var min = parseInt($input.attr('data-min')) || 0;
    var max = parseInt($input.attr('data-max')) || 99;
    var $atcBtn = $(picker).find('.js-wl-qty-atc');
    var mode = picker.getAttribute('data-mode');
    var cartQty = parseInt(picker.getAttribute('data-cart-qty')) || 0;

    if ($this.hasClass('js-wl-qty-minus')) {
      val = Math.max(min, val - 1);
    } else {
      val = Math.min(max, val + 1);
    }
    $input.val(val);

    if (mode === 'update') {
      if (val === 0) $atcBtn.text('REMOVE');
      else if (val !== cartQty) $atcBtn.text('UPDATE CART');
      else $atcBtn.text('IN CART');
    }
  });

  // Wishlist qty ATC button — mirrors catalog logic exactly
  $(document).on('click', '.js-wl-qty-atc', function(event) {
    event.preventDefault();
    event.stopPropagation();
    var btn = event.currentTarget;
    var $btn = $(btn);
    var picker = btn.closest('.era-wishlist__qty-picker');
    if (!picker) return;

    var variantId = parseInt($(picker).data('variant-id'));
    var qty = parseInt(picker.querySelector('.js-wl-qty-value').value) || 0;
    var mode = picker.getAttribute('data-mode');

    // Don't do anything if qty unchanged in update mode
    var cartQty = parseInt(picker.getAttribute('data-cart-qty')) || 0;
    if (mode === 'update' && qty === cartQty) return;

    $btn.prop('disabled', true).text(qty === 0 ? 'REMOVING...' : 'UPDATING...');

    var url, body;
    if (mode === 'update') {
      // Use change.js to set absolute quantity (0 = remove)
      url = '/cart/change.js';
      body = JSON.stringify({ id: String(variantId), quantity: qty });
    } else {
      url = '/cart/add.js';
      body = JSON.stringify({ items: [{ id: variantId, quantity: qty }] });
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) { throw data; });
      }
      return response.json();
    })
    .then(function(data) {
      if (qty === 0) {
        $btn.text('REMOVED');
        theme.toast.show('Removed from cart', 'info');
      } else if (mode === 'update') {
        $btn.text('UPDATED!');
        theme.toast.show('Cart updated!', 'success');
      } else {
        $btn.text('ADDED!');
        theme.toast.show('Added to cart!', 'success');
      }

      // generateCart already fetches /cart.js and updates counts + free shipping
      if (theme.miniCart && theme.miniCart.generateCart) theme.miniCart.generateCart();

      setTimeout(function() {
        $(picker).closest('.era-wishlist__qty-slot').empty();
        $(picker).closest('.era-wishlist__card').find('.js-wl-size-btn').removeClass('selected');
      }, 1200);
    })
    .catch(function(err) {
      var msg = (err && err.description) ? err.description : 'Could not update cart';
      theme.toast.show(msg, 'error');
      $btn.prop('disabled', false).text(mode === 'update' ? 'UPDATE CART' : 'ADD TO CART');
    });
  });

  // Legacy single-variant wishlist ATC (products with no size option)
  $(document).on('click', '.js-wishlist-atc', function (event) {
    event.preventDefault();
    handleWishlistAddToCart(this);
  });

  $(document).on('click', btnRemoveWishlist, function () {
    const productHandle = $(this).data('handle');
    const allSimilarProducts = $(`${btnWishlist}[data-handle="${productHandle}"]`);

    allSimilarProducts.html(`${theme.strings.wishlistIcon}${theme.strings.wishlistText}`);
    allSimilarProducts.attr('data-original-title', theme.strings.wishlistText);
    allSimilarProducts.removeClass('added');

    const productIndex = wishlist.indexOf(productHandle);
    if (productIndex !== -1) {
      wishlist.splice(productIndex, 1);
      localStorage.setItem('localWishlist', JSON.stringify(wishlist));
    }

    var $card = $(this).closest('.js-wishlist-item');

    // Toast
    theme.toast.show('Removed from wishlist', 'info');

    // Phase 1: Scratch it out — strikethrough text, desaturate image, diagonal line
    $card.addClass('era-wishlist--scraping');

    // Phase 2: Collapse and remove
    setTimeout(function() {
      $card.addClass('era-wishlist--collapsing');
      $card.on('transitionend', function handler(e) {
        if (e.originalEvent.propertyName !== 'max-height') return;
        $card.off('transitionend', handler);
        $card.remove();
        if (wishlist.length === 0) {
          showNoResult();
          $('.js-wishlist-footer').hide();
        } else {
          // Smoothly re-assign left/right directions
          reindexCards(true);
          // Recalculate subtotal
          var remaining = wishlist.length;
          var newSubtotal = 0;
          wishlist.forEach(function(h) {
            jQuery.getJSON(window.Shopify.routes.root + 'products/' + h + '.js', function(p) {
              newSubtotal += p.price;
              remaining--;
              if (remaining === 0) {
                $('.js-wishlist-subtotal').text(theme.Currency.formatMoney(newSubtotal, theme.moneyFormat));
              }
            }).fail(function() { remaining--; });
          });
        }
      });
    }, 900);

    $wishlistCount.text(wishlist.length);
  });

  loadWishlist();
  $(document).on('shopify:section:load', loadWishlist);

  return {
    load: loadWishlist
  };
})();

// Wishlist Dropdown (header)
theme.wishlistDropdown = (function() {
  var $dropdown = $('.js-wishlist-dropdown'),
      $toggle = $('.js-toggle-wishlist-dropdown'),
      $closeBtn = $('.js-close-wishlist-dropdown'),
      $overlay = $('.overlay-wishlist-dropdown'),
      $itemsContainer = $('.js-wishlist-dropdown-items'),
      $miniCart = $('.js-mini-cart'),
      cachedKey = null,      // stringified recent handles when last fetched
      cachedHtml = null;     // rendered HTML from that fetch

  function open() {
    // Close cart dropdown if open
    $miniCart.removeClass('active');
    $dropdown.addClass('active');

    var wishlist = JSON.parse(localStorage.getItem('localWishlist')) || [];
    var recent = wishlist.slice(-3).reverse();
    var key = JSON.stringify(recent);

    if (key === cachedKey) {
      // Wishlist hasn't changed — show cached content instantly, no loader
      if (cachedHtml) {
        $itemsContainer.html('<div class="wishlist-dropdown-items-inner visible">' + cachedHtml + '</div>');
      } else {
        renderEmpty();
      }
    } else {
      fetchItems(wishlist, recent, key);
    }
  }

  function close() {
    $dropdown.removeClass('active');
  }

  function toggle() {
    if ($dropdown.hasClass('active')) {
      close();
    } else {
      open();
    }
  }

  var loaderSvg =
    '<div class="wishlist-dropdown-loading">' +
      '<svg class="wishlist-loading-svg" viewBox="0 0 849 146" xmlns="http://www.w3.org/2000/svg">' +
        '<path class="wishlist-loading-outline" fill="none" stroke="currentColor" stroke-width="3" d="M474.1000,0.000 C491.665,0.000 508.335,0.000 524.1000,0.000 C527.905,4.612 532.153,8.387 533.1000,14.000 C533.667,14.000 533.333,14.000 532.1000,14.000 C529.100,17.949 504.593,33.910 498.1000,35.000 C493.017,22.794 479.350,11.950 474.1000,0.000 ZM41.1000,10.000 C85.662,10.000 129.338,10.000 172.1000,10.000 C172.1000,10.333 172.1000,10.667 172.1000,11.000 C165.503,18.225 158.084,28.611 151.1000,37.000 C150.667,39.333 149.333,41.667 147.1000,44.000 C115.003,44.000 81.997,44.000 48.1000,44.000 C47.616,45.105 46.127,45.494 44.000,46.000 C41.954,49.241 41.012,50.032 40.1000,56.000 C41.804,57.021 41.355,56.274 41.1000,57.1000 C50.548,61.876 62.433,61.1000 75.1000,61.1000 C119.768,62.000 165.612,54.910 173.1000,90.1000 C178.482,110.285 167.350,122.657 158.000,128.1000 C143.204,139.039 121.776,139.000 95.1000,139.000 C64.003,139.000 31.997,139.000 -0.000,139.000 C-0.000,138.333 -0.000,137.667 -0.000,136.1000 C7.794,131.589 15.411,119.640 20.1000,112.000 C22.022,110.603 22.675,106.842 23.1000,105.1000 C58.330,105.1000 92.670,105.1000 126.1000,105.1000 C132.709,101.816 136.248,103.731 135.1000,92.1000 C135.196,91.979 135.645,92.726 134.1000,90.1000 C134.000,90.667 132.1000,90.333 131.1000,90.000 C126.911,86.298 113.362,88.000 104.1000,88.000 C84.355,87.1000 53.143,91.667 35.000,86.1000 C15.934,82.096 3.899,72.527 3.1000,48.000 C4.039,38.526 5.976,31.578 10.000,26.000 C14.157,20.238 23.696,14.379 31.000,12.000 C34.585,10.833 39.179,11.741 41.1000,10.000 ZM652.1000,10.000 C668.665,10.000 684.335,10.000 700.000,10.000 C700.000,10.667 700.000,11.333 700.000,12.000 C689.877,19.396 680.564,39.205 673.000,50.000 C656.946,72.910 639.517,95.773 624.000,119.000 C615.1000,130.976 600.010,154.686 576.1000,140.1000 C563.237,132.814 546.015,100.275 536.000,86.000 C528.262,74.971 510.212,56.232 506.000,44.000 C512.711,40.171 536.698,22.544 541.000,23.000 C557.998,47.664 575.002,72.336 592.000,97.000 C592.333,97.000 592.667,97.000 592.1000,97.000 C596.480,86.478 606.961,77.591 613.000,68.1000 C621.872,56.378 629.145,43.634 638.000,30.1000 C642.847,24.085 648.944,17.879 652.1000,10.000 ZM749.1000,44.000 C749.1000,49.333 749.1000,54.667 749.1000,59.1000 C780.330,59.1000 810.670,59.1000 841.000,59.1000 C841.000,60.333 841.000,60.667 841.000,61.000 C833.916,66.633 827.338,77.701 821.1000,84.1000 C821.194,86.102 821.024,89.335 820.000,90.000 C796.669,90.000 773.331,90.000 749.1000,90.000 C749.1000,95.666 749.1000,101.334 749.1000,106.1000 C782.997,106.1000 816.003,106.1000 849.000,106.1000 C849.000,107.667 849.000,108.333 849.000,108.1000 C841.346,114.318 834.408,126.440 829.000,133.1000 C827.925,135.503 827.549,139.186 826.000,139.1000 C787.670,139.1000 749.330,139.1000 711.000,139.1000 C711.000,140.333 711.000,140.667 711.000,140.1000 C710.667,140.1000 710.333,140.1000 710.000,140.1000 C710.000,98.004 710.000,54.996 710.000,12.000 C709.667,12.000 709.333,12.000 709.000,12.000 C708.010,10.990 709.985,11.012 710.000,11.000 C715.014,7.887 739.839,9.1000 748.000,10.000 C780.997,10.000 814.003,10.000 847.000,10.000 C847.000,10.667 847.000,11.333 847.000,12.000 C840.059,16.846 832.866,28.115 828.000,35.000 C826.380,37.293 825.244,42.571 823.000,44.000 C798.669,44.000 774.331,44.000 749.1000,44.000 ZM261.1000,139.1000 C248.668,139.1000 235.332,139.1000 222.000,139.1000 C222.000,108.670 222.000,77.330 222.000,46.000 C218.873,44.921 213.586,44.935 209.000,45.000 C202.070,40.596 168.171,44.788 158.1000,45.000 C158.1000,44.333 158.1000,43.667 158.1000,43.000 C164.729,38.883 176.403,23.160 180.1000,17.000 C182.036,15.612 182.671,11.845 184.000,11.000 C231.662,11.000 279.338,11.000 326.1000,11.000 C326.1000,11.333 326.1000,11.667 326.1000,12.000 C320.240,17.401 311.246,30.772 306.000,37.1000 C304.667,40.333 303.333,42.667 302.000,45.000 C288.668,45.000 275.332,45.000 261.1000,45.000 C262.1000,50.507 262.000,64.221 261.1000,72.1000 C261.1000,95.331 261.1000,117.669 261.1000,139.1000 ZM351.1000,105.1000 C351.1000,117.332 351.1000,128.668 351.1000,139.1000 C338.335,139.1000 324.665,139.1000 311.000,139.1000 C313.362,119.528 311.053,95.932 311.000,75.000 C341.330,75.000 371.670,75.000 401.1000,75.000 C422.386,75.000 439.153,75.814 450.000,66.1000 C452.390,61.356 451.444,56.832 450.000,50.1000 C443.374,46.839 436.146,42.921 423.1000,44.000 C420.667,44.333 417.333,44.667 413.1000,45.000 C407.691,43.943 393.536,45.000 384.000,45.000 C360.336,45.000 336.664,45.000 312.1000,45.000 C312.1000,44.333 312.1000,43.667 312.1000,43.000 C321.332,32.334 329.667,21.666 337.1000,11.000 C371.997,11.000 406.003,11.000 439.1000,11.000 C444.211,13.546 450.943,12.356 456.000,14.000 C464.547,16.779 473.336,21.040 480.000,26.000 C494.038,36.448 497.903,67.527 486.000,83.1000 C478.762,94.017 469.569,92.825 460.000,99.000 C469.052,104.945 477.474,114.360 484.000,122.1000 C488.750,129.289 496.556,133.265 501.000,139.1000 C483.002,139.1000 464.998,139.1000 447.000,139.1000 C442.942,133.531 423.750,108.757 417.000,106.1000 C413.333,104.698 403.500,106.000 397.1000,105.1000 C382.668,105.1000 367.332,105.1000 351.1000,105.1000 Z"/>' +
        '<path class="wishlist-loading-fill" fill="currentColor" d="M474.1000,0.000 C491.665,0.000 508.335,0.000 524.1000,0.000 C527.905,4.612 532.153,8.387 533.1000,14.000 C533.667,14.000 533.333,14.000 532.1000,14.000 C529.100,17.949 504.593,33.910 498.1000,35.000 C493.017,22.794 479.350,11.950 474.1000,0.000 ZM41.1000,10.000 C85.662,10.000 129.338,10.000 172.1000,10.000 C172.1000,10.333 172.1000,10.667 172.1000,11.000 C165.503,18.225 158.084,28.611 151.1000,37.000 C150.667,39.333 149.333,41.667 147.1000,44.000 C115.003,44.000 81.997,44.000 48.1000,44.000 C47.616,45.105 46.127,45.494 44.000,46.000 C41.954,49.241 41.012,50.032 40.1000,56.000 C41.804,57.021 41.355,56.274 41.1000,57.1000 C50.548,61.876 62.433,61.1000 75.1000,61.1000 C119.768,62.000 165.612,54.910 173.1000,90.1000 C178.482,110.285 167.350,122.657 158.000,128.1000 C143.204,139.039 121.776,139.000 95.1000,139.000 C64.003,139.000 31.997,139.000 -0.000,139.000 C-0.000,138.333 -0.000,137.667 -0.000,136.1000 C7.794,131.589 15.411,119.640 20.1000,112.000 C22.022,110.603 22.675,106.842 23.1000,105.1000 C58.330,105.1000 92.670,105.1000 126.1000,105.1000 C132.709,101.816 136.248,103.731 135.1000,92.1000 C135.196,91.979 135.645,92.726 134.1000,90.1000 C134.000,90.667 132.1000,90.333 131.1000,90.000 C126.911,86.298 113.362,88.000 104.1000,88.000 C84.355,87.1000 53.143,91.667 35.000,86.1000 C15.934,82.096 3.899,72.527 3.1000,48.000 C4.039,38.526 5.976,31.578 10.000,26.000 C14.157,20.238 23.696,14.379 31.000,12.000 C34.585,10.833 39.179,11.741 41.1000,10.000 ZM652.1000,10.000 C668.665,10.000 684.335,10.000 700.000,10.000 C700.000,10.667 700.000,11.333 700.000,12.000 C689.877,19.396 680.564,39.205 673.000,50.000 C656.946,72.910 639.517,95.773 624.000,119.000 C615.1000,130.976 600.010,154.686 576.1000,140.1000 C563.237,132.814 546.015,100.275 536.000,86.000 C528.262,74.971 510.212,56.232 506.000,44.000 C512.711,40.171 536.698,22.544 541.000,23.000 C557.998,47.664 575.002,72.336 592.000,97.000 C592.333,97.000 592.667,97.000 592.1000,97.000 C596.480,86.478 606.961,77.591 613.000,68.1000 C621.872,56.378 629.145,43.634 638.000,30.1000 C642.847,24.085 648.944,17.879 652.1000,10.000 ZM749.1000,44.000 C749.1000,49.333 749.1000,54.667 749.1000,59.1000 C780.330,59.1000 810.670,59.1000 841.000,59.1000 C841.000,60.333 841.000,60.667 841.000,61.000 C833.916,66.633 827.338,77.701 821.1000,84.1000 C821.194,86.102 821.024,89.335 820.000,90.000 C796.669,90.000 773.331,90.000 749.1000,90.000 C749.1000,95.666 749.1000,101.334 749.1000,106.1000 C782.997,106.1000 816.003,106.1000 849.000,106.1000 C849.000,107.667 849.000,108.333 849.000,108.1000 C841.346,114.318 834.408,126.440 829.000,133.1000 C827.925,135.503 827.549,139.186 826.000,139.1000 C787.670,139.1000 749.330,139.1000 711.000,139.1000 C711.000,140.333 711.000,140.667 711.000,140.1000 C710.667,140.1000 710.333,140.1000 710.000,140.1000 C710.000,98.004 710.000,54.996 710.000,12.000 C709.667,12.000 709.333,12.000 709.000,12.000 C708.010,10.990 709.985,11.012 710.000,11.000 C715.014,7.887 739.839,9.1000 748.000,10.000 C780.997,10.000 814.003,10.000 847.000,10.000 C847.000,10.667 847.000,11.333 847.000,12.000 C840.059,16.846 832.866,28.115 828.000,35.000 C826.380,37.293 825.244,42.571 823.000,44.000 C798.669,44.000 774.331,44.000 749.1000,44.000 ZM261.1000,139.1000 C248.668,139.1000 235.332,139.1000 222.000,139.1000 C222.000,108.670 222.000,77.330 222.000,46.000 C218.873,44.921 213.586,44.935 209.000,45.000 C202.070,40.596 168.171,44.788 158.1000,45.000 C158.1000,44.333 158.1000,43.667 158.1000,43.000 C164.729,38.883 176.403,23.160 180.1000,17.000 C182.036,15.612 182.671,11.845 184.000,11.000 C231.662,11.000 279.338,11.000 326.1000,11.000 C326.1000,11.333 326.1000,11.667 326.1000,12.000 C320.240,17.401 311.246,30.772 306.000,37.1000 C304.667,40.333 303.333,42.667 302.000,45.000 C288.668,45.000 275.332,45.000 261.1000,45.000 C262.1000,50.507 262.000,64.221 261.1000,72.1000 C261.1000,95.331 261.1000,117.669 261.1000,139.1000 ZM351.1000,105.1000 C351.1000,117.332 351.1000,128.668 351.1000,139.1000 C338.335,139.1000 324.665,139.1000 311.000,139.1000 C313.362,119.528 311.053,95.932 311.000,75.000 C341.330,75.000 371.670,75.000 401.1000,75.000 C422.386,75.000 439.153,75.814 450.000,66.1000 C452.390,61.356 451.444,56.832 450.000,50.1000 C443.374,46.839 436.146,42.921 423.1000,44.000 C420.667,44.333 417.333,44.667 413.1000,45.000 C407.691,43.943 393.536,45.000 384.000,45.000 C360.336,45.000 336.664,45.000 312.1000,45.000 C312.1000,44.333 312.1000,43.667 312.1000,43.000 C321.332,32.334 329.667,21.666 337.1000,11.000 C371.997,11.000 406.003,11.000 439.1000,11.000 C444.211,13.546 450.943,12.356 456.000,14.000 C464.547,16.779 473.336,21.040 480.000,26.000 C494.038,36.448 497.903,67.527 486.000,83.1000 C478.762,94.017 469.569,92.825 460.000,99.000 C469.052,104.945 477.474,114.360 484.000,122.1000 C488.750,129.289 496.556,133.265 501.000,139.1000 C483.002,139.1000 464.998,139.1000 447.000,139.1000 C442.942,133.531 423.750,108.757 417.000,106.1000 C413.333,104.698 403.500,106.000 397.1000,105.1000 C382.668,105.1000 367.332,105.1000 351.1000,105.1000 Z"/>' +
      '</svg>' +
    '</div>';

  var ANIM_DURATION = 1000; // matches CSS animation duration (1s)

  function invalidateCache() {
    cachedKey = null;
    cachedHtml = null;
  }

  function fetchItems(wishlist, recent, key) {
    if (wishlist.length === 0) {
      cachedKey = key;
      cachedHtml = null;
      renderEmpty();
      return;
    }

    // Show loader SVG immediately
    $itemsContainer.html(loaderSvg);
    var animStart = Date.now();

    var fetches = recent.map(function(handle) {
      return fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    });

    Promise.all(fetches).then(function(products) {
      var validProducts = products.filter(function(p) { return p !== null; });
      // Wait for SVG fill animation to finish before revealing items
      var elapsed = Date.now() - animStart;
      var remaining = Math.max(0, ANIM_DURATION - elapsed);

      setTimeout(function() {
        var $loader = $itemsContainer.find('.wishlist-dropdown-loading');
        $loader.addClass('fade-out');

        setTimeout(function() {
          if (validProducts.length === 0) {
            cachedKey = key;
            cachedHtml = null;
            renderEmpty();
          } else {
            var html = buildItemsHtml(validProducts);
            cachedKey = key;
            cachedHtml = html;
            renderItems(validProducts);
          }
        }, 250); // matches fade-out transition
      }, remaining);
    });
  }

  function buildItemsHtml(products) {
    var html = '';
    products.forEach(function(product) {
      var imageUrl = product.featured_image
        ? product.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2')
        : '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693571571c306f858ee8f71.gif';
      var price = theme.Currency.formatMoney(product.price, theme.moneyFormat);
      var title = product.title || '';

      html += '<a href="' + product.url + '" class="wishlist-dropdown-item">' +
        '<img class="wishlist-dropdown-item-img" src="' + imageUrl + '" alt="' + title.replace(/"/g, '&quot;') + '">' +
        '<div class="wishlist-dropdown-item-info">' +
          '<p class="wishlist-dropdown-item-title">' + title + '</p>' +
          '<span class="wishlist-dropdown-item-price">' + price + '</span>' +
        '</div>' +
      '</a>';
    });
    return html;
  }

  function renderItems(products) {
    var html = '<div class="wishlist-dropdown-items-inner">' + buildItemsHtml(products) + '</div>';
    $itemsContainer.html(html);
    // Trigger reflow then fade in
    $itemsContainer[0].offsetHeight;
    $itemsContainer.find('.wishlist-dropdown-items-inner').addClass('visible');
  }

  function renderEmpty() {
    $itemsContainer.html(
      '<div class="wishlist-dropdown-items-inner">' +
      '<div class="wishlist-dropdown-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' +
        '<p>Your wishlist is empty</p>' +
      '</div></div>'
    );
    $itemsContainer[0].offsetHeight;
    $itemsContainer.find('.wishlist-dropdown-items-inner').addClass('visible');
  }

  // Toggle on heart icon click
  $(document).on('click', '.js-toggle-wishlist-dropdown', function(e) {
    e.preventDefault();
    e.stopPropagation();
    toggle();
  });

  // Close on X button
  $(document).on('click', '.js-close-wishlist-dropdown', function(e) {
    e.preventDefault();
    e.stopPropagation();
    close();
  });

  // Close on overlay click
  $(document).on('click', '.overlay-wishlist-dropdown', function() {
    close();
  });

  // Close wishlist when cart is opened
  $(document).on('click', '.js-toggle-cart', function() {
    close();
  });

  return {
    refresh: invalidateCache,
    open: open,
    close: close
  };
})();



// Compare
theme.compare = (function (){
  var compareButtonClass = '.js-btn-compare',
      compareRemoveButtonClass = '.js-remove-compare',
      $compareCount = $('.js-compare-count'),
      $compareContainer = $('.js-compare-content'),
      compareObject = JSON.parse(localStorage.getItem('localCompare')) || [],
      alertClass='notice';
  function updateCompare(self) {
    var productHandle = $(self).data('handle'),
        alertText = '';
    var isAdded = $.inArray(productHandle,compareObject) !== -1 ? true:false;
    if (isAdded) {
      compareObject.splice(compareObject.indexOf(productHandle), 1);
      alertText = theme.strings.compareNotifyRemoved;
      alertClass = 'notice';
    }else{
      if (compareObject.length === 4){
        alertText = theme.strings.compareNotifyMaximum;
        alertClass = 'error';
      }else{
        alertClass = 'notice';
        compareObject.push(productHandle);
        alertText = theme.strings.compareNotifyAdded;
      }
    }
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    theme.alert.new(theme.strings.compareText,alertText,2000,alertClass);
    $compareCount.text(compareObject.length);
  };
  function loadCompare(){
    var compareGrid;
    $compareContainer.html('');
    //popup compare
    if (compareObject.length > 0){
      compareGrid = compareObject.length === 1? 'col-md-12 col-sm-6' : 'col';
      for (var i = 0; i < compareObject.length; i++) { 
        var productHandle = compareObject[i];
        Shopify.getProduct(productHandle,function(product){
          var htmlProduct = '',
              productPrice = product.price_varies? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat),
              productComparePrice = product.compare_at_price_min !== 0 ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '',
              productAvailable = product.available ? theme.strings.available : theme.strings.unavailable,
              productAvailableClass = product.available ? 'alert-success' : 'alert-danger',
              productTypeHTML = product.type !== "" ? '<a class="link" href="/collections/types?q='+ product.type +'">'+ product.type +'</a>' : '<span>'+ theme.strings.none +'</span>',
              productVendorHTML = product.vendor !== "" ? '<a class="link" href="/collections/vendors?q='+ product.vendor +'">'+ product.vendor +'</a>' : '<span>'+ theme.strings.none +'</span>';
          htmlProduct += '<div class="compare-item '+compareGrid+' col-xs-6 px-0">';
          htmlProduct += '  <p class="py-3"><button class="js-remove-compare link " data-handle="'+product.handle+'">'+ theme.strings.compareTextRemove +'</button></p>';
          htmlProduct += '	<a class="d-block mb-4 px-4" href="'+ product.url +'">';
          htmlProduct += '		<img src="'+ Shopify.resizeImage(product.featured_image,'x230') +'"/>';
          htmlProduct += '	</a>';
          htmlProduct += '	<hr /><h5 >'+ product.title +'</h5>';
          htmlProduct += '	<hr /><s class="small">'+ productComparePrice +'</s>';
          htmlProduct += '	<span> '+ productPrice +'</span>';
          htmlProduct += '	<hr /><span class="px-2 py-1 rounded '+ productAvailableClass +'"> '+ productAvailable +'</span>';
          htmlProduct += '	<hr />'+ productTypeHTML;
          htmlProduct += '	<hr /><div class="pb-3">'+ productVendorHTML+'</div>';
          htmlProduct += '</div>';
          $compareContainer.append(htmlProduct);
          //theme.updateCurrencies();
        });
      }
    }else{
      $compareContainer.html('<div class="alert alert-warning d-inline-block mb-0">'+ theme.strings.compareNoResult + '</div>');
    }
    
    //button text
    $(compareButtonClass).each(function(){
      var productHandle = $(this).data('handle');
      var status = $.inArray(productHandle,compareObject) !== -1 ? 'added' : '';
      $(this).removeClass('added').addClass(status);
    });

    //count items
    $compareCount.text(compareObject.length);
  }
  $(document).on('click',compareButtonClass,function (event) {
    event.preventDefault();
    updateCompare(this);
    loadCompare();
  });
  $(document).on('click',compareRemoveButtonClass,function(){
    var productHandle = $(this).data('handle');
    compareObject.splice(compareObject.indexOf(productHandle), 1);
    localStorage.setItem('localCompare', JSON.stringify(compareObject)); 
    loadCompare();
  });

  loadCompare();
  $(document).on('shopify:section:load', loadCompare);
  return{
    load:loadCompare
  }
})()

// Popup newsletter
theme.popupNewletter = (function(){
  function popupNewletter(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      popupSection : '.popupnew-' + sectionId,
      formSection : '#jsPopupNewsletter' + sectionId
    }
    this.init();
  }
  popupNewletter.prototype = _.assignIn({}, popupNewletter.prototype, {
    init: function() {
      this.showPopup();
    },
    showPopup: function(){
      var $popupNewsletter = $(this.selectors.formSection),
          $newsletterForm = $(this.selectors.formSection).find("form"),
          date = new Date(),
          minutes = theme.timePopupNewsletter;
          minutesdelay = $popupNewsletter.attr('data-delay');
      if ($popupNewsletter.length === 1){
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        var setCookies = function (){
          $.cookie('cookiesNewsletter', 'disabled', { expires: date, path: '/' } );
        };
        if ($.cookie('cookiesNewsletter') !== "disabled") {
          $(window).on('load',function(){
            setTimeout(function () {
              $popupNewsletter.modal('show');
            }, minutesdelay * 1000);
          });
          $popupNewsletter.on('hidden.bs.modal', setCookies);
          $newsletterForm.submit(setCookies);     
        }
      }
      if(Shopify.designMode){
        document.addEventListener('shopify:section:select', function(event){
          $(event.target).find($popupNewsletter).modal('show');
        });
        document.addEventListener('shopify:section:deselect', function(event){
          $(event.target).find($popupNewsletter).modal('hide');
        });
      }
    }
  });
  
  return popupNewletter;
})()


theme.BeforeAfter = (function(){
  function BeforeAfter(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      bablockSection : '#beer-slider-' + sectionId
    }
    this.init();
  }
  BeforeAfter.prototype = _.assignIn({}, BeforeAfter.prototype, {
    init: function() {
      this.showBeforeAfter();
    },
    showBeforeAfter: function(){
      var $baBlock = $(this.selectors.bablockSection);
      $.fn.BeerSlider = function ( options ) {
        options = options || {};
        return this.each(function() {
          new BeerSlider(this, options);
        });
      };
      $($baBlock).BeerSlider({start: 50});
    }
  });
  
  return BeforeAfter;
})()

// Popup newsletter
theme.FooterSection = (function(){
  function FooterSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var enableAcc = Boolean($container.attr('data-acc'));
    this.selectors = {
      footerSection : '.footer-' + sectionId,
      enableAcc : enableAcc,
    }
    this.init();
  }
  FooterSection.prototype = _.assignIn({}, FooterSection.prototype, {
    init: function() {
      this.accordionResponsive();
    },

    accordionResponsive: function(){

        //var mqr = window.matchMedia('screen and (max-width: 749px)');
        if (this.selectors.enableAcc == true){
          /*var acc = document.getElementsByClassName("site-footer__section-title");
          var i;
          for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function() {
              this.classList.toggle("active");
              var panel = this.nextElementSibling;
              if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
              } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
              }
            });
          }
          */
          $('.site-footer__section-title').click(function() {
            $(this).toggleClass('active');
            $(this).next().slideToggle('fast');
            return false;
          });
        }
    }
  });
  
  return FooterSection;
})()


// Open external link in new tab
theme.exLink = (function(){
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname && $(links[i]).attr('href') !== 'javascript:void(0)') {
      links[i].target = '_blank';
    }
  }
})()


// Collection view - Collection page
theme.collectionView =  (function (){
  var btnView = '.js-btn-view',
      btnViewActive = '.js-btn-view.active';

  $(document).on('click',btnView,function(){
    var value = $(this).data('col'),
        $gridItemCol = $('.js-col');

    $(btnView).removeClass('active');
    $(this).addClass('active');

    $gridItemCol.removeClass().addClass('js-col col-sm-6 col-6');
    if (value === 3){
      $gridItemCol.addClass('col-lg-4');
    }else if(value === 4){
      $gridItemCol.addClass('col-lg-3');
    }else if(value === 5){
      $gridItemCol.addClass('col-lg-2-4');
    }else if(value === 6){
      $gridItemCol.addClass('col-lg-2');
    };
  })

  function triggerCollectionView(){
    $(btnViewActive).trigger('click');
  }

  return {
    triggerView:triggerCollectionView
  }
})()

// Swath variant in card item
theme.swatchCard = (function() {
  const $swatches = '.js-swatch-card-item';
  const $image = '.product-card__image img';
  const $cart = '.js-grid-cart';

  function handleSwatchClick() {
    const $swatch = $(this);
    const newImage = $swatch.data('image');
    const id = $swatch.data('id');
    const $card = $swatch.closest('.js-product-card');

    $card.find($swatches).removeClass('active');
    $swatch.addClass('active');

    $card.find($image).attr('srcset', newImage);
    $card.find($cart).data('id', id);
  }

  $(document).on('click', $swatches, handleSwatchClick);
})();




theme.swatchCard2 = (function(){
  function initVariant(id){
    var productJson = JSON.parse($('.customJson-' + id).html());
    var $selectorForm = $('.customform-' + id);
    var $button = $('.js-customform-addtocart-' + id);
    var $buttontext = $button.find('span');
    var $wrapObject = $selectorForm.closest('.js-product-card');
    var options = {
      $container: $selectorForm,
      enableHistoryState: false,
      product: productJson,
      singleOptionSelector: '.single-option-selector-' + id,
      originalSelectorId: '#ProductSelect-' + id
    };
    var variants = new slate.Variants(options);
    var AjaxCart = new window.AjaxCart($selectorForm);
    var _updateButton = function (evt){
      var variant = evt.variant;
      if (variant === undefined){
        $button.prop('disabled', true).removeClass('btn--sold-out');
        $buttontext.html(theme.strings.unavailable);
      }else{
        if (variant.available){
          $button.removeClass('btn--sold-out').prop('disabled', false);
          $buttontext.html(theme.strings.addToCart);
        }else{
          $button.prop('disabled', true).addClass('btn--sold-out');
          $buttontext.html(theme.strings.soldOut);
        }
      }
    }
    var _updateImage = function (evt){
      var variant = evt.variant;
      var $mainImage = $wrapObject.find('.product-card__image').find('img');
      if (variant !== undefined && variant.featured_image !== null){
        var variantImage = variant.featured_image;
        $mainImage.attr('srcset',variantImage.src);
      }
    }
    var _updatePrice = function (evt){
      var $price = $wrapObject.find('.product-card__price');
      var variant = evt.variant;
      if (variant !== undefined){
        var htmlComparePrice = variant.compare_at_price !== null ? '<s class="product-card__regular-price"><span class="money">'+variant.compare_at_price+'</span></s>' : '';
        var htmlPrice = '<span class="money">'+variant.price+'</span>' + htmlComparePrice ;
        $price.html(htmlPrice);
        //theme.updateCurrencies();
      }
    }
    variants.$container.on(
      'variantChange' , _updateButton
    );
    variants.$container.on(
      'variantChange' , _updateImage
    );
    variants.$container.on(
      'variantChange' , _updatePrice
    );
  }
  function initForm(){
    $('.js-customform').each(function(){
      var id = $(this).data('id');
      initVariant(id);
    })
  }

  initForm();
  return{
    load:initForm
  }
})()

// Loading
theme.loading = (function(){
  var $loading = $('#js-loading'),
      hasLoading = $('#js-loading').length === 0? false : true;
  if (hasLoading){
    $(window).load(function () {
      $loading.fadeOut();
    });  
  }
})()

theme.effectLeavingPage = (function(){
  window.onbeforeunload = function(){
    $('body').css('opacity','0');
  }
})()





theme.bundleProduct = (function(){
  function bundleProduct(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.selectors = {
      bundleSection : '#bundle-' + sectionId
    }
    this.init();
  }
  bundleProduct.prototype = _.assignIn({}, bundleProduct.prototype, {
    init: function() {
      this.bundleList();
    },
    bundleList : function(){
      let variantSelectClass = '.fbtproduct-form__variants',
      parentClass = '.fbt-item',
      totalPrice = '.fpt-total',
      totalPriceCompare = '.fpt-totalcompare',
      totalSave = '.fpt-save',
      checkBox = '.fbt-checkbox';

        updateTotal();
        checkItem();
        
        // change update variant
        $(document).on('change',variantSelectClass,function(){
          var selectVariant = $(this).children(':selected'),
              selectVariantId = selectVariant.data('id'),
              newPrice = theme.Currency.formatMoney(selectVariant.data('price'), theme.moneyFormat);
              newPriceCompare = theme.Currency.formatMoney(selectVariant.data('price-compare'), theme.moneyFormat);
              
          if (selectVariant.data('image') !== ''){
            $(this).closest(parentClass).find('img').attr({
              "src": selectVariant.data('image'),
              "data-srcset" : selectVariant.data('image'),
              "srcset" : selectVariant.data('image')
            });
          }
          $(this).closest(parentClass).attr('data-item',selectVariantId);
          $(this).closest(parentClass).find('.fbt-price').attr('data-fbtprice',selectVariant.data('price'));
          $(this).closest(parentClass).find('.fbt-price').html(newPrice);
          if (selectVariant.data('price-compare') !== undefined) {
            $(this).closest(parentClass).find('.fbt-price-compare').html(newPriceCompare).removeClass('hide');    
            $(this).closest(parentClass).find('.fbt-price-compare').attr('data-price-at',selectVariant.data('price-compare'));
          } else {
            $(this).closest(parentClass).find('.fbt-price-compare').attr('data-price-at','').addClass('hide');
          }
          updateTotal();
        });
        
        // checkChecked
        function checkItem(){
          $(checkBox).change(function() {
            if(this.checked) {
              $(this).closest(parentClass).attr('data-checked',true);
            }
            else{
              $(this).closest(parentClass).attr('data-checked',false);
            }
            updateTotal();
          });
        }
        function updateTotal(){
          let total = 0;
          let totalCompare = 0;
          $('.fbt-item-price').each(function() {
            let isChecked = $(this).closest('.fbt-item').find('.fbt-checkbox').is(':checked');
            let isPriceCompare = $(this).find('.fbt-price-compare').attr('data-price-at');
            if (isChecked){
              let value = parseFloat($(this).find('.fbt-price').attr('data-fbtprice'));
              
              total += value;
              if( isPriceCompare !== undefined && isPriceCompare !== '' ){
                let valueCompare = parseFloat(isPriceCompare);
                totalCompare += valueCompare
              }
            }
          });
          //console.log(totalCompare); 
          $(totalPrice).html(theme.Currency.formatMoney(total, theme.moneyFormat));
            let totalSale  = totalCompare + total ;
            if( totalSale > total){
                $(totalPriceCompare).show();
                $(totalSave).show().html(`${$(totalSave).attr('data-txtsave')} <span class="text-theme">${theme.Currency.formatMoney(totalSale - total , theme.moneyFormat)}</span>` );
            }
            else{
              $(totalPriceCompare).hide();
              $(totalSave).hide().html();
            }
          $(totalPriceCompare).html(theme.Currency.formatMoney(totalCompare + total , theme.moneyFormat));
        }
        //click add product
        $('#fbt-button').click(function(e) {
          e.preventDefault();
          function addMultipleItemsToCart(productsToAdd) {
            var cartUrl = '/cart/add.js';
            var cartData = {
              items: productsToAdd
            };
          
            $.ajax({
              type: 'POST',
              url: cartUrl,
              data: cartData,
              dataType: 'json',
              beforeSend: function() {
                // console.log($(this));
                $('#fbt-button').addClass('is-loading');
              },
              success: function(data) {
                $('#fbt-button').removeClass('is-loading');
                theme.miniCart.generateCart();
              },
              error: function(XMLHttpRequest, textStatus,err) {
                $('#fbt-button').removeClass('is-loading');
                // console.log(err);
              }
            });
          }
          var productsToAdd = $(parentClass).map(function() {
            if($(this).attr('data-checked') === 'true' ){
              return {
                id: parseInt($(this).attr('data-item')),
                quantity: 1,
              };
            }
            
          }).get();
          // console.log(productsToAdd);
          addMultipleItemsToCart(productsToAdd);
        });
    }
  });
  return bundleProduct;
})()




// Upsell
theme.upsell = (function() {
  const upsellPopupSelector = '#jsUpsell';
  const $acceptButton = $('#jsUpsell .btn');
  const upsellProductId = $('#jsUpsell').data('id') || '';
  const acceptButtonClass = 'js-btn-accept';
  const delayTime = $('#jsUpsell').data('delay') || 3000;
  const isUpsellActive = $(upsellPopupSelector).length === 1;

  function showUpsellPopupWithDelay() {
    setTimeout(() => {
      $(upsellPopupSelector).modal('show');
    }, delayTime);
  }

  function handleAcceptButtonClick() {
    const isAcceptButton = $acceptButton.hasClass(acceptButtonClass);
    
    if (isAcceptButton) {
      Shopify.addItem(upsellProductId, 1, item => {
        theme.miniCart.generateCart();

        const variantInfo = item.variant_title !== null ? `<i>(${item.variant_title})</i>` : '';
        const alertContent = `<div class="media mt-2 alert--cart"><a class="mr-3" href="/cart"><img class="lazyload" data-src="${item.image}"></a><div class="media-body align-self-center"><p class="m-0 font-weight-bold">${item.product_title} x ${item.quantity}</p>${variantInfo}<div><div>`;
        
        theme.alert.new(theme.strings.addToCartSuccess, alertContent, 3000, 'notice');
      });
    }
    
    $(upsellPopupSelector).modal('hide');
  }

  if (isUpsellActive) {
    $(document).ready(showUpsellPopupWithDelay);
    $acceptButton.on('click', handleAcceptButtonClick);
  }
})();




// Overwrite Shopify.onError in Shopify API
Shopify.onError = function(t, r) {
    var e = eval("(" + t.responseText + ")");
    var mess = e.message ? e.message + "(" + e.status + "): " + e.description : "Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + "."
    theme.alert.new('Alert',mess,3000,'warning');
}


// Fake-viewers
theme.fakeViewer = (function() {
  var $fakeViewClass = $('.js-fake-view'),
      minValue = $fakeViewClass.data('min'),
      maxValue = $fakeViewClass.data('max'),
      duration = $fakeViewClass.data('duration');

  function updateFakeViewCount() {
    var value = Math.floor(Math.random() * (maxValue - minValue + 1)) + minValue;
    $fakeViewClass.text(value);
  }

  function initFakeViewCount() {
    updateFakeViewCount();

    if (minValue !== undefined && maxValue !== undefined && duration) {
      setInterval(updateFakeViewCount, duration);
    }
  }

  initFakeViewCount();
})();


// Product-suggest
theme.productSuggest = (function() {
  var $productNotification = $('.product-notification'),
      $closeButton = $('.close-notifi'),
      suggestionDuration = $productNotification.data('time') || 0,
      suggestionCookie = 'productSuggestClosed';

  function closeSuggestion() {
    $productNotification.remove();
    $.cookie(suggestionCookie, 'closed', { expires: 1, path: '/' });
  }

  function toggleSuggestion() {
    if ($productNotification.hasClass('active')) {
      $productNotification.removeClass('active');
    } else {
      var $productItems = $('.data-product'),
          randomIndex = Math.floor(Math.random() * $productItems.length),
          $selectedProduct = $($productItems[randomIndex]);

      $productNotification.addClass('active');
      var $productImage = $productNotification.find('.product-image img');
      $productImage.attr({
        'src': $selectedProduct.data('image'),
        'width': $selectedProduct.data('wimage'),
        'height': $selectedProduct.data('himage')
      });
      $productNotification.find('.product-image').attr({
        'href': $selectedProduct.data('url'),
        'title': $selectedProduct.data('title')
      });
      $productNotification.find('.product-name').text($selectedProduct.data('title')).attr('href', $selectedProduct.data('url'));
      $productNotification.find('.time-ago').text($selectedProduct.data('time'));
      $productNotification.find('.from-ago').text($selectedProduct.data('local'));
    }
  }

  function handleSuggestionInterval() {
    if (suggestionDuration !== 0) {
      setInterval(toggleSuggestion, suggestionDuration);
    }
  }

  function init() {
    if ($.cookie(suggestionCookie) === 'closed') {
      $productNotification.remove();
    } else {
      $closeButton.on('click', closeSuggestion);
      handleSuggestionInterval();
    }
  }

  init();
})();




theme.activeAccordion = (function(){
  $('.collapse').on('shown.bs.collapse', function () {
       $(this).prev().addClass('active-acc');
   });
   $('.collapse').on('hidden.bs.collapse', function () {
       $(this).prev().removeClass('active-acc');
   });
})()


// Anchor scroll
theme.anchorScroll = (function() {
  $(document).on('click', 'a[href^="#"]', function(event) {
    event.preventDefault();
    
    var $clickedLink = $(this);
    var disableAnchor = $clickedLink.hasClass('disabled-anchor');
    
    if (!disableAnchor) {
      var target = $clickedLink.attr('href');
      var targetOffsetTop = $(target).offset().top;
      
      $('html, body').animate({
        scrollTop: targetOffsetTop
      }, 500);
    }
  });
})();


// Product-recently-viewed
theme.productRecentlyViewed = (function() {
  var $recentViewedElement = $('.js-recently-view'),
      $viewButton = $('.js-recently-view-button'),
      $content = $('.js-recently-view-content'),
      currentProductHandle = $recentViewedElement.data('handle') || '',
      productLimit = $viewButton.data('limit') || 0,
      recentlyViewedArray = JSON.parse(localStorage.getItem('localRecentlyViewed')) || [],
      imageSize = $('#jsRecentlyViewed').attr("data-sizeimage");

  function processRecentlyViewed() {
    if (currentProductHandle) {
      var lastProductIndex = recentlyViewedArray.lastIndexOf(currentProductHandle);
      if (lastProductIndex !== -1) {
        recentlyViewedArray.splice(lastProductIndex, 1);
      }
      recentlyViewedArray.push(currentProductHandle);

      if (recentlyViewedArray.length > productLimit) {
        recentlyViewedArray.shift();
      }
      localStorage.setItem('localRecentlyViewed', JSON.stringify(recentlyViewedArray));
    }
  }

  function generateProductHtml(product) {
    var productPrice = product.price_varies ? 'from ' + theme.Currency.formatMoney(product.price_min, theme.moneyFormat) : theme.Currency.formatMoney(product.price, theme.moneyFormat);
    var productComparePrice = product.compare_at_price_min !== 0 ? theme.Currency.formatMoney(product.compare_at_price_min, theme.moneyFormat) : '';
    var priceSaleClass = productComparePrice ? 'rc-sale' : 'rc-nosale';

    var productHtml = `
      <div class="col-6 col-lg-2 js-viewed-item mb-4">
        <div class="d-flex flex-column">
          <a class="w-100 recent-img ${imageSize}" href="${product.url}">
            <img class="lazyload" loading="lazy" data-src="${product.featured_image}&width=340"/>
          </a>
          <div class="text-center">
            <div class="mt-2"><a class="product-card__name" href="${product.url}">${product.title}</a></div>
            <span class="${priceSaleClass}">${productPrice}</span>
            <s class="small">${productComparePrice}</s>
          </div>
        </div>
      </div>`;
    
    return productHtml;
  }

  function updateViewButtonImage(product) {
    $viewButton.css('background-image', 'url(' + product.featured_image + ')').addClass('active');
  }

  processRecentlyViewed();
  
  if (recentlyViewedArray.length > 0) {
    // array of products
    recentlyViewedArray.forEach(function(productHandle) {
      Shopify.getProduct(productHandle, function(product) {
        var productHtml = generateProductHtml(product);
        $content.append(productHtml);
      });
    });

    // last product
    Shopify.getProduct(recentlyViewedArray[recentlyViewedArray.length - 1], function(product) {
      updateViewButtonImage(product);
    });
  }
})();

// Notice when soldout
theme.alert = (function(){
  function stripTags(s){ return String(s || '').replace(/<[^>]*>/g, '').trim(); }
  function createAlert(title, mess, _time, type){
    var aTitle = stripTags(title);
    var aMessage = stripTags(mess);
    // Empty payloads — silently bail
    if (!aTitle && !aMessage) return;

    // Route through the cart drawer's dark toast if it exists; otherwise stay silent
    if (window.cartDrawerTabs && typeof window.cartDrawerTabs.showError === 'function') {
      var toastType = (type === 'success' || type === 'notice') ? 'success' : 'error';
      window.cartDrawerTabs.showError(mess || '', aTitle || (toastType === 'success' ? 'Notice' : 'Alert'), toastType);
    }
    // No more $.growl — the legacy growl popup is purged
  }

  return {
    new: createAlert
  }
})()

// Notice when soldout
theme.noticeSoldout = (function(){
  var $soldoutWrapFormClass = $('.js-contact-soldout'),
      $textClass = $('.js-notify-text'),
      $soldoutValueId = $('#ContactProduct');
  function noticeSoldout(variant){
    $soldoutWrapFormClass.find('.form-success').remove()
    if (variant.available){
      $textClass.find('span').text('');
      $soldoutWrapFormClass.addClass('hide');
    }else{
      $textClass.find('span').text(+ variant.name);
      $soldoutWrapFormClass.removeClass('hide');
      $soldoutValueId.val(variant.name).attr('value',variant.name);
    }
  }
  return {
    init : noticeSoldout
  }
})()

// Sticky cart
theme.stickyCart = (function() {
  var $anchor = $('#js-anchor-sticky-cart'),
      $stickyCartWrapper = $('.sticky-cart-wr');

  if ($anchor.length) {
    function handleStickyCart() {
      var anchorTop = $anchor.offset().top,
          anchorHeight = $anchor.outerHeight(),
          windowHeight = $(window).height(),
          windowScroll = $(window).scrollTop();

      $stickyCartWrapper.toggleClass('active', windowScroll > (anchorTop + anchorHeight - windowHeight));
    }

    $(window).on('scroll', handleStickyCart);
    handleStickyCart();
  }
})();

//Fix reload safari
window.addEventListener("pageshow", function(evt){
  if(evt.persisted){
  setTimeout(function(){
      window.location.reload();
  },10);
}
}, false);

// Back to top
theme.backToTop = (function(){
  $(document).ready(function(){"use strict";
  var progressPath = document.querySelector('.progress-wrap path');
  if ( progressPath != null ){
  var pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';    
  var updateProgress = function () {
    var scroll = $(window).scrollTop();
    var height = $(document).height() - $(window).height();
    var progress = pathLength - (scroll * pathLength / height);
    progressPath.style.strokeDashoffset = progress;
  }
  updateProgress();
  $(window).scroll(updateProgress); 
  var offset = 50;
  var duration = 550;
  jQuery(window).on('scroll', function() {
    if (jQuery(this).scrollTop() > offset) {
      jQuery('.progress-wrap').addClass('active-progress');
    } else {
      jQuery('.progress-wrap').removeClass('active-progress');
    }
  });       
  jQuery('.progress-wrap').on('click', function(event) {
    event.preventDefault();
    jQuery('html, body').animate({scrollTop: 0}, duration);
    return false;
  })
}

});
})()

theme.popOver = (function(){
  $('body').on('click', function (e) {
    $('[data-hotspot]').each(function () {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).next().removeClass('active');
        }
        else{
          $(this).next().addClass('active');
        }
    });
});
  
})()


// Tooltip
theme.tooltip = (function(){
  var selector = '[data-toggle="tooltip"],[data-tooltip="true"]';
  function loadTooltip(){
    $(selector).tooltip(); //Bootstrap 4
  };
  $(document).on('click',selector,function(){
    $(this).tooltip('hide');
  });
  loadTooltip();
  return{
    load:loadTooltip
  }
})()

//Collections style 2
theme.Bgcollection = (function(){
    function Bgcollection(container){
     var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');
     var wrapper = this.wrapper = '.bgcollection-wrapper';
     var slider = this.slider = '#Bgcollection-' + sectionId;
     var $slider = $(slider, wrapper);
     $(".colgrid__bg--full[data-index='1']").addClass('active');
     $('.colgrid .colgrid__box').each(function(){
           var index = $(this).attr("data-index");
           $(this).hover(
           function() {
              $(".colgrid__bg--full[data-index='"+index+"']").addClass('active');
           }, 
           function() {
                 $(".colgrid__bg--full[data-index='"+index+"']").removeClass('active');
              }
           );
        });
      }
    return Bgcollection;
  })();


theme.hasInput = (function(){
  var inPut= $('.form-group .form-control');

  inPut.blur(function (){
    if(!this.value){
      $(this).removeClass('has-value');
    }else{
      $(this).addClass('has-value');
    }
  });

  var inpuSearch = $('#Search-In-Template');
  if (inpuSearch.length != 0 ) {
    if(inpuSearch.val().length != 0 ){
      inpuSearch.addClass('has-value');
    }
  }
  else{
    return;
  }
  
})()
// Toast notification
theme.toast = (function() {
  var ICONS = {
    success: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
    error:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
    info:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>'
  };

  function show(message, type) {
    var existing = document.querySelector('.era-toast');
    if (existing) existing.remove();

    var toastType = type || 'info';
    var icon = ICONS[toastType] || ICONS.info;

    var toast = document.createElement('div');
    toast.className = 'era-toast era-toast--' + toastType;
    toast.innerHTML = '<span class="era-toast__icon" aria-hidden="true">' + icon + '</span><span class="era-toast__text"></span>';
    toast.querySelector('.era-toast__text').textContent = message;
    document.body.appendChild(toast);

    // Trigger entrance
    requestAnimationFrame(function() {
      toast.classList.add('era-toast--visible');
    });

    setTimeout(function() {
      toast.classList.remove('era-toast--visible');
      setTimeout(function() { toast.remove(); }, 300);
    }, 3000);
  }
  return { show: show };
})();

// Size Add to Cart Functionality
theme.sizeAddToCart = (function() {
  var sizeButtonClass = '.js-size-add-cart';
  var activeCard = null;

  function buildQtyPicker(variantId, sizeName, cartQty) {
    var isUpdate = cartQty > 0;
    var btnLabel = isUpdate ? 'UPDATE CART' : 'ADD TO CART';
    var startQty = isUpdate ? cartQty : 1;

    return '<div class="product-card__qty-picker" data-variant-id="' + variantId + '" data-mode="' + (isUpdate ? 'update' : 'add') + '" data-cart-qty="' + cartQty + '">' +
      '<div class="product-card__qty-picker-size">' + sizeName + (isUpdate ? ' <span class="product-card__qty-picker-badge">' + cartQty + ' in cart</span>' : '') + '</div>' +
      '<div class="product-card__qty-picker-row">' +
        '<div class="product-card__qty-controls">' +
          '<button type="button" class="product-card__qty-btn js-qty-minus" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" class="product-card__qty-input js-qty-value" value="' + startQty + '" min="' + (isUpdate ? '0' : '1') + '" max="99" readonly>' +
          '<button type="button" class="product-card__qty-btn js-qty-plus" aria-label="Increase quantity">&plus;</button>' +
        '</div>' +
        '<button type="button" class="product-card__qty-atc js-qty-add-cart">' + btnLabel + '</button>' +
      '</div>' +
    '</div>';
  }

  function closeActivePicker() {
    if (activeCard) {
      var picker = activeCard.querySelector('.product-card__qty-picker');
      if (picker) picker.remove();
      activeCard = null;
    }
  }

  function updateCartCount() {
    return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      $('.js-cart-count').text(cart.item_count);
      theme.freeShipping.load(cart);
    });
  }

  function handleSizeClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var $button = $(event.currentTarget);
    if ($button.prop('disabled') || $button.hasClass('loading')) return;

    var variantId = $button.data('variant-id');
    if (!variantId) return;

    var card = event.currentTarget.closest('.product-card__image-wr');
    if (!card) return;

    // Close any existing picker
    closeActivePicker();

    // Highlight selected size
    $(card).find('.js-size-add-cart').removeClass('selected');
    $button.addClass('selected');

    // Fetch cart to check if variant already exists
    var sizeName = $button.text().trim();
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartQty = 0;
        var numericId = parseInt(variantId);
        cart.items.forEach(function(item) {
          if (item.variant_id === numericId || item.id === numericId) {
            cartQty = item.quantity;
          }
        });
        $(card).find('.product-card__sizes-box').after(buildQtyPicker(variantId, sizeName, cartQty));
        activeCard = card;
      });
  }

  function handleQtyChange(event) {
    event.preventDefault();
    event.stopPropagation();
    var picker = event.currentTarget.closest('.product-card__qty-picker');
    if (!picker) return;
    var input = picker.querySelector('.js-qty-value');
    var val = parseInt(input.value) || 0;
    var min = parseInt(input.getAttribute('min')) || 0;
    var btn = picker.querySelector('.js-qty-add-cart');
    var mode = picker.getAttribute('data-mode');
    var cartQty = parseInt(picker.getAttribute('data-cart-qty')) || 0;

    if ($(event.currentTarget).hasClass('js-qty-minus')) {
      val = Math.max(min, val - 1);
    } else {
      val = Math.min(99, val + 1);
    }
    input.value = val;

    // Update button label based on context
    if (mode === 'update') {
      if (val === 0) {
        btn.textContent = 'REMOVE';
      } else if (val !== cartQty) {
        btn.textContent = 'UPDATE CART';
      } else {
        btn.textContent = 'IN CART';
      }
    }
  }

  function handleAddToCart(event) {
    event.preventDefault();
    event.stopPropagation();
    var btn = event.currentTarget;
    var $btn = $(btn);
    var picker = btn.closest('.product-card__qty-picker');
    if (!picker) return;

    var variantId = parseInt($(picker).data('variant-id'));
    var qty = parseInt(picker.querySelector('.js-qty-value').value) || 0;
    var mode = picker.getAttribute('data-mode');

    // Don't do anything if qty unchanged in update mode
    var cartQty = parseInt(picker.getAttribute('data-cart-qty')) || 0;
    if (mode === 'update' && qty === cartQty) return;

    $btn.prop('disabled', true).text(qty === 0 ? 'REMOVING...' : 'UPDATING...');

    var url, body;
    if (mode === 'update') {
      // Use change.js to set absolute quantity (0 = remove)
      url = '/cart/change.js';
      body = JSON.stringify({ id: String(variantId), quantity: qty });
    } else {
      url = '/cart/add.js';
      body = JSON.stringify({ items: [{ id: variantId, quantity: qty }] });
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) { throw data; });
      }
      return response.json();
    })
    .then(function(data) {
      if (qty === 0) {
        $btn.text('REMOVED');
        theme.toast.show('Removed from cart', 'info');
      } else if (mode === 'update') {
        $btn.text('UPDATED!');
        theme.toast.show('Cart updated!', 'success');
      } else {
        $btn.text('ADDED!');
        theme.toast.show('Added to cart!', 'success');
      }

      // generateCart already fetches /cart.js and updates counts + free shipping
      theme.miniCart.generateCart();

      setTimeout(function() {
        closeActivePicker();
      }, 1000);

      if (theme.cartpage) {
        location.reload();
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }
    })
    .catch(function(err) {
      var msg = (err && err.description) ? err.description : 'Could not update cart';
      theme.toast.show(msg, 'error');
      $btn.prop('disabled', false).text(mode === 'update' ? 'UPDATE CART' : 'ADD TO CART');
    });
  }

  function init() {
    $(document).on('click', sizeButtonClass, handleSizeClick);
    $(document).on('click', '.js-qty-minus, .js-qty-plus', handleQtyChange);
    $(document).on('click', '.js-qty-add-cart', handleAddToCart);
    // Close picker when clicking outside
    $(document).on('click', function(e) {
      if (activeCard && !$(e.target).closest('.product-card__qty-picker, .js-size-add-cart').length) {
        closeActivePicker();
      }
    });
  }

  return {
    init: init
  };
})();

// Initialize size add to cart
theme.sizeAddToCart.init();

$(theme.init);

class CountdownTimer extends HTMLElement {
  connectedCallback() {
    if (!this.countdownInitialized) {
      this.countdownInitialized = true; 

      const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

      const countDownDate = new Date(this.getAttribute('data-time')).getTime();
      const countdownContainer = document.createElement('div'); 

      this.appendChild(countdownContainer);

      function updateCountdown() {
        const now = new Date().getTime();
        const distance = countDownDate - now;

        const days = Math.floor(distance / day);
        const hours = Math.floor((distance % day) / hour);
        const minutes = Math.floor((distance % hour) / minute);
        const seconds = Math.floor((distance % minute) / second);

        countdownContainer.innerHTML = `
        <ul class="list--inline or-countdown">
          <li>
          <span class="countdown-time">${days}</span><span class="countdown-text">Days</span> <span class="hide countdown-time-single">D</span>
          </li>
          <li>
          <span class="countdown-time">${hours}</span> <span class="countdown-text">Hours</span> <span class="hide countdown-time-single">H</span>
          </li>
          <li>
          <span class="countdown-time">${minutes}</span> <span class="countdown-text">Mins</span> <span class="hide countdown-time-single">M</span>
          </li>
          <li>
          <span class="countdown-time">${seconds}</span> <span class="countdown-text">Secs</span> <span class="hide countdown-time-single">S</span>
          </li>
          </ul>
        `;

        if (distance > 0) {
          requestAnimationFrame(updateCountdown);
        } else {
          countdownContainer.innerHTML = "Countdown Finished!";
        }
      }

      updateCountdown();
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);


class CheckoutButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('a[name="checkout"]');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('checkout-button', CheckoutButton);

/* ========== SpotlightSearch – Desktop Spotlight Overlay ========== */
window.SpotlightSearch = (function() {
  'use strict';

  var isOpen = false;
  var debounceTimer = null;
  var searchCache = {};
  var DEBOUNCE_MS = 300;
  var RECENT_KEY = 'spotlight_recent_searches';
  var RECENT_MAX = 8;
  var TRENDING_KEY = 'spotlight_trending';
  var TRENDING_TTL = 5 * 60 * 1000; // 5 minutes

  // Product preview cache (keyed by handle)
  var productCache = {};

  // DOM refs (lazy-cached)
  var els = {};

  function getEls() {
    if (els._cached) return els;
    els.overlay = document.querySelector('.spotlight-overlay');
    els.spotlight = document.querySelector('.spotlight-search');
    els.input = document.getElementById('Spotlight-Search-Input');
    els.form = document.querySelector('[data-spotlight-form]');
    els.closeBtn = document.querySelector('[data-spotlight-close]');
    els.resultsWrap = document.querySelector('[data-spotlight-results]');
    els.resultsGrid = document.querySelector('[data-spotlight-results-grid]');
    els.trendingGrid = document.querySelector('[data-spotlight-trending-grid]');
    els.recentPills = document.querySelector('[data-spotlight-recent-pills]');
    els.loading = document.querySelector('[data-spotlight-loading]');
    els.searchFor = document.querySelector('[data-spotlight-search-for]');
    els.searchTerm = document.querySelector('[data-spotlight-search-term]');
    els.initials = document.querySelectorAll('[data-spotlight-initial]');
    els.preview = document.querySelector('[data-spotlight-preview]');
    els.previewImg = els.preview ? els.preview.querySelector('.spotlight-search__preview-img') : null;
    els.previewTitle = els.preview ? els.preview.querySelector('.spotlight-search__preview-title') : null;
    els.previewSizes = els.preview ? els.preview.querySelector('.spotlight-search__preview-sizes') : null;
    els.previewCta = els.preview ? els.preview.querySelector('.spotlight-search__preview-cta') : null;
    els._cached = true;
    bindEvents();
    return els;
  }

  function bindEvents() {
    els.overlay.addEventListener('click', close);
    els.closeBtn.addEventListener('click', close);
    els.input.addEventListener('input', onInput);
    if (els.previewCta) {
      els.previewCta.addEventListener('click', function(ev) {
        ev.stopPropagation();
        var href = els.previewCta.getAttribute('href');
        if (href && href !== '#') {
          window.location.href = href;
        }
      });
    }
    els.form.addEventListener('submit', onSubmit);
    document.addEventListener('keydown', onKeydown);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && isOpen) {
      close();
    }
  }

  function onInput() {
    var term = els.input.value.trim();
    if (term.length === 0) {
      clearResults();
      showInitialState();
      return;
    }
    // Update "Search for" link
    els.searchFor.style.display = '';
    els.searchTerm.textContent = term;
    els.searchFor.href = routes.predictive_search_url
      ? window.location.origin + '/search?q=' + encodeURIComponent(term) + '&type=product'
      : '/search?q=' + encodeURIComponent(term) + '&type=product';

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      performSearch(term);
    }, DEBOUNCE_MS);
  }

  function onSubmit(e) {
    e.preventDefault();
    var term = els.input.value.trim();
    if (term.length > 0) {
      saveRecentSearch(term);
    }
    // Stay on page — user can click "Search for X" link to navigate
  }

  /* ---------- OPEN / CLOSE ---------- */

  function open() {
    var e = getEls();
    if (!e.overlay) return;
    isOpen = true;
    e.overlay.classList.add('active');
    e.spotlight.classList.add('active');
    document.body.classList.add('spotlight-active');
    document.body.style.overflow = 'hidden';
    e.input.value = '';
    clearResults();
    showInitialState();
    setTimeout(function() { e.input.focus(); }, 50);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    els.overlay.classList.remove('active');
    els.spotlight.classList.remove('active');
    document.body.classList.remove('spotlight-active');
    document.body.style.overflow = '';
    els.input.value = '';
    clearResults();
    hidePreview();
  }

  /* ---------- INITIAL STATE ---------- */

  function showInitialState() {
    var e = getEls();
    // Hide all initial blocks first
    e.initials.forEach(function(el) { el.style.display = 'none'; });
    e.searchFor.style.display = 'none';

    // Always show trending
    show('[data-spotlight-initial="trending"]');
    loadTrendingProducts();

    // ALSO show recents on top if they exist (CSS handles visual ordering)
    var recents = getRecentSearches();
    if (recents.length > 0) {
      renderRecentSearches();
      show('[data-spotlight-initial="recent"]');
    }
  }

  function show(sel) {
    var el = document.querySelector(sel);
    if (el) el.style.display = '';
  }

  /* ---------- PREDICTIVE SEARCH ---------- */

  function performSearch(term) {
    var cacheKey = term.replace(/\s+/g, '-').toLowerCase();
    if (searchCache[cacheKey]) {
      renderProducts(searchCache[cacheKey]);
      return;
    }
    showLoading(true);
    var url = (routes.predictive_search_url || '/search/suggest')
      + '?q=' + encodeURIComponent(term)
      + '&resources[type]=product&resources[limit]=4&section_id=predictive-search';

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('.predictive-search__list-item');
        var products = [];
        items.forEach(function(li) {
          var link = li.querySelector('.predictive-search__item--link');
          if (!link) return;
          var img = link.querySelector('img');
          var title = link.querySelector('.predictive-search__item-heading');
          var priceEl = link.querySelector('.price-item--regular, .price-item--sale, .price .money, .price-item');
          products.push({
            url: link.getAttribute('href'),
            image: img ? img.getAttribute('src') : '',
            title: title ? title.textContent.trim() : '',
            price: priceEl ? priceEl.textContent.trim() : ''
          });
        });
        searchCache[cacheKey] = products;
        renderProducts(products);
      })
      .catch(function() {
        showLoading(false);
      });
  }

  function renderProducts(products) {
    var e = getEls();
    showLoading(false);

    if (products.length === 0) {
      e.resultsWrap.style.display = '';
      e.resultsGrid.innerHTML = '<p style="font-size:14px;color:rgba(0,0,0,0.5);">No products found.</p>';
      return;
    }

    var html = '';
    products.forEach(function(p) {
      html += '<a href="' + p.url + '" class="spotlight-search__result-item">';
      if (p.image) {
        html += '<img class="spotlight-search__result-img" src="' + p.image.replace(/width=\d+/, 'width=100') + '" alt="" loading="lazy">';
      }
      html += '<div class="spotlight-search__result-info">';
      html += '<div class="spotlight-search__result-title">' + p.title + '</div>';
      if (p.price) html += '<div class="spotlight-search__result-price">' + p.price + '</div>';
      html += '</div></a>';
    });
    e.resultsGrid.innerHTML = html;
    e.resultsWrap.style.display = '';

    // Attach preview click events on result items (never navigate, use CTA instead)
    e.resultsGrid.querySelectorAll('.spotlight-search__result-item').forEach(function(item) {
      item.addEventListener('click', function(ev) {
        ev.preventDefault();
        var href = item.getAttribute('href') || '';
        var match = href.match(/\/products\/([^?#\/]+)/);
        if (!match) return;
        var handle = match[1];

        // Skip if already showing this product
        if (currentPreviewHandle === handle) return;

        // Deselect previous
        var prev = e.resultsGrid.querySelector('.preview-selected');
        if (prev) prev.classList.remove('preview-selected');
        item.classList.add('preview-selected');

        fetchProduct(handle).then(function(product) {
          showPreview(product);
        }).catch(function() {
          hidePreview();
        });
      });
    });
  }

  function clearResults() {
    var e = getEls();
    e.resultsWrap.style.display = 'none';
    e.resultsGrid.innerHTML = '';
    showLoading(false);
    hidePreview();
  }

  function showLoading(on) {
    var e = getEls();
    e.loading.style.display = on ? '' : 'none';
  }

  /* ---------- TRENDING PRODUCTS ---------- */

  function loadTrendingProducts() {
    var e = getEls();
    // Check sessionStorage cache
    var cached = sessionStorage.getItem(TRENDING_KEY);
    if (cached) {
      try {
        var data = JSON.parse(cached);
        if (Date.now() - data.ts < TRENDING_TTL) {
          renderTrendingCards(data.products);
          return;
        }
      } catch(ex) {}
    }
    showLoading(true);
    fetch('/collections/all/products.json?sort_by=best-selling&limit=4')
      .then(function(res) { return res.json(); })
      .then(function(json) {
        var products = (json.products || []).slice(0, 4).map(function(p) {
          return {
            url: '/products/' + p.handle,
            image: p.images && p.images[0] ? p.images[0].src : '',
            title: p.title,
            price: p.variants && p.variants[0] ? theme.Currency.formatMoney(p.variants[0].price, theme.moneyFormat) : ''
          };
        });
        sessionStorage.setItem(TRENDING_KEY, JSON.stringify({ ts: Date.now(), products: products }));
        renderTrendingCards(products);
      })
      .catch(function() { showLoading(false); });
  }

  function renderTrendingCards(products) {
    var e = getEls();
    showLoading(false);
    var html = '';
    products.forEach(function(p) {
      html += '<a href="' + p.url + '" class="spotlight-search__card">';
      if (p.image) html += '<img src="' + p.image.replace(/(\.\w+)\?/, '$1?width=300&') + '" alt="" loading="lazy">';
      html += '<div class="spotlight-search__card-info">';
      html += '<div class="spotlight-search__card-title">' + p.title + '</div>';
      if (p.price) html += '<div class="spotlight-search__card-price">' + p.price + '</div>';
      html += '</div></a>';
    });
    e.trendingGrid.innerHTML = html;
  }

  /* ---------- RECENT SEARCHES ---------- */

  function getRecentSearches() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch(e) { return []; }
  }

  function saveRecentSearch(term) {
    var searches = getRecentSearches();
    // Remove duplicate
    searches = searches.filter(function(s) { return s.toLowerCase() !== term.toLowerCase(); });
    searches.unshift(term);
    if (searches.length > RECENT_MAX) searches = searches.slice(0, RECENT_MAX);
    localStorage.setItem(RECENT_KEY, JSON.stringify(searches));
  }

  function renderRecentSearches() {
    var e = getEls();
    var searches = getRecentSearches();
    if (!searches.length) return;
    var html = '';
    searches.forEach(function(term) {
      html += '<button type="button" class="spotlight-search__pill" data-term="' + term.replace(/"/g, '&quot;') + '">' + term + '</button>';
    });
    e.recentPills.innerHTML = html;
    // Bind clicks
    e.recentPills.querySelectorAll('.spotlight-search__pill').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var t = this.getAttribute('data-term');
        e.input.value = t;
        e.input.dispatchEvent(new Event('input'));
      });
    });
  }

  /* ---------- PRODUCT PREVIEW ---------- */

  function fetchProduct(handle) {
    if (productCache[handle]) {
      return Promise.resolve(productCache[handle]);
    }
    return fetch('/products/' + handle + '.json')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        productCache[handle] = data.product;
        return data.product;
      });
  }

  var currentPreviewHandle = null;

  function showPreview(product) {
    var e = getEls();
    if (!e.preview || !window.matchMedia('(min-width: 1200px)').matches) return;

    // Skip if already showing this product
    if (currentPreviewHandle === product.handle) return;
    currentPreviewHandle = product.handle;

    // Title (instant)
    e.previewTitle.textContent = product.title || '';

    // Sizes (instant)
    var sizes = [];
    if (product.options) {
      product.options.forEach(function(opt) {
        var name = (opt.name || '').toLowerCase();
        if (name === 'size' || name === 'taille' || name === 'talla' || name === 'größe') {
          sizes = opt.values || [];
        }
      });
    }
    if (sizes.length > 0) {
      var sizeHtml = '';
      sizes.forEach(function(s) {
        sizeHtml += '<span class="spotlight-search__preview-size">' + s + '</span>';
      });
      e.previewSizes.innerHTML = sizeHtml;
      e.previewSizes.style.display = '';
    } else {
      e.previewSizes.innerHTML = '';
      e.previewSizes.style.display = 'none';
    }

    // CTA (instant)
    e.previewCta.href = '/products/' + product.handle;
    e.previewCta.style.display = '';

    // Image — show skeleton placeholder, fade in real image once loaded
    var imgSrc = product.images && product.images.length > 0
      ? product.images[0].src
      : (product.image ? product.image.src : '');

    if (imgSrc) {
      var loaded = false;
      var skeletonShown = false;
      var img = new Image();
      img.onload = function() {
        loaded = true;
        if (currentPreviewHandle !== product.handle) return;
        if (skeletonShown) {
          // Skeleton was visible — fade image in
          img.className = 'spotlight-search__preview-fade';
          e.previewImg.innerHTML = '';
          e.previewImg.appendChild(img);
          img.offsetWidth;
          img.classList.add('loaded');
        } else {
          // Fast load — just show it directly
          e.previewImg.innerHTML = '';
          e.previewImg.appendChild(img);
        }
      };
      img.onerror = function() {
        loaded = true;
        e.previewImg.innerHTML = '';
      };
      img.src = imgSrc.replace(/(\.\w+)\?/, '$1?width=600&');
      img.alt = '';
      // Only show skeleton if image hasn't loaded after 100ms
      setTimeout(function() {
        if (!loaded && currentPreviewHandle === product.handle) {
          skeletonShown = true;
          e.previewImg.innerHTML = '<div class="spotlight-search__preview-skeleton"></div>';
        }
      }, 100);
    } else {
      e.previewImg.innerHTML = '';
    }

    // Open panel
    e.spotlight.classList.add('preview-active');
  }

  function hidePreview() {
    var e = getEls();
    e.spotlight.classList.remove('preview-active');
    currentPreviewHandle = null;
  }

  return { open: open, close: close };
})();
